import * as THREE from 'https://cdn.shopify.com/s/files/1/0918/7154/3624/files/three.module.js?v=1789231161';

// Live: the theme's asset map, else the Content > Files URL (files added after the map was last edited). Local: the relative path.
const A = (p) => { const n = p.split('/').pop(); if (!window.FND_ASSETS) return p; return window.FND_ASSETS[n] || 'https://cdn.shopify.com/s/files/1/0918/7154/3624/files/fnd-' + n; };
function canvasTex(draw, w = 256, h = 256, repX = 6, repY = 1) {
  const c = document.createElement('canvas'); c.width = w; c.height = h;
  draw(c.getContext('2d'), w, h);
  const t = new THREE.CanvasTexture(c);
  t.wrapS = t.wrapT = THREE.RepeatWrapping; t.repeat.set(repX, repY);
  t.colorSpace = THREE.SRGBColorSpace;
  return t;
}
// photo textures (from the merchant's own material shots); procedural TEX below is the fallback
const PHOTOS = {
  meteorite: ['assets/tex-meteorite.png', 3, 1, true],
  antler: ['assets/tex-antler.png', 3, 1, true],
  oak: ['assets/tex-oak.png', 6, 1, true],
  redopal: ['assets/tex-redopal.png', 4, 1, true],
  cosmos: ['assets/tex-cosmos.jpg', 5, 1, true],
  crushedmet: ['assets/tex-crushedmet.png', 3, 1, true],
  sandstone: ['assets/tex-sandstone.jpg', 4, 1, true],
  blueopal: ['assets/tex-blueopal.jpg', 4, 1, true],
  abalone: ['assets/tex-abalone.png', 4, 1, true],
  greenopal: ['assets/tex-greenopal.png', 4, 1, true],
  mossagate: ['assets/tex-mossagate.png', 4, 1, true],
  carbonblack: ['assets/tex-carbon-black.png', 4, 1, true],
  carboncopper: ['assets/tex-carbon-copper.png', 4, 1, true],
  carbongold: ['assets/tex-carbon-gold.png', 4, 1, true],
  carbonsilver: ['assets/tex-carbon-silver.png', 4, 1, true],
  carbonrosegold: ['assets/tex-carbon-rosegold.png', 4, 1, true],
  carbonblue: ['assets/tex-carbon-blue.png', 4, 1, true],
  sandphoto: ['assets/tex-sandblasted.jpeg', 4, 2, false],
  sandrelief: ['assets/tex-sandblasted-relief.png', 3, 1, true],
  hammerphoto: ['assets/tex-hammered.jpg', 6, 1, false],
  hammerrelief: ['assets/tex-hammered-relief.png', 3, 1, true],
  facetrelief: ['assets/tex-faceted-relief.png', 3, 1, true],
  facetrelief2: ['assets/tex-faceted2-relief.png', 3, 1, true],
  roughrelief: ['assets/tex-roughbrushed-relief.png', 2, 1, true],
  // the merchant's own coarse brushed hammer shot: broad tool marks, not the fine dimple pattern
  coarsehammer: ['assets/tex-coarsehammer.jpg', 5, 1, false],
};
const TEX = {
  meteorite: () => canvasTex((g, w, h) => {
    g.fillStyle = '#98a0aa'; g.fillRect(0, 0, w, h);
    // Widmanstatten: angular patches, each with parallel etched bands at its own angle
    for (let p = 0; p < 8; p++) {
      const cx = Math.random() * w, cy = Math.random() * h, n = 3 + Math.floor(Math.random() * 3);
      g.save(); g.beginPath();
      for (let k = 0; k <= n; k++) { const a = (k / n) * Math.PI * 2 + p; const r = 60 + Math.random() * 90; const x = cx + Math.cos(a) * r, y = cy + Math.sin(a) * r; k ? g.lineTo(x, y) : g.moveTo(x, y); }
      g.closePath(); g.clip();
      g.translate(cx, cy); g.rotate(Math.random() * Math.PI); g.translate(-cx, -cy);
      const sp = 5 + Math.random() * 4;
      for (let y = -h; y < h * 2; y += sp) {
        g.fillStyle = (Math.floor(y / sp) % 2) ? 'rgba(70,78,88,0.55)' : 'rgba(198,205,214,0.5)';
        g.fillRect(-w, y, w * 3, sp * (0.35 + Math.random() * 0.25));
      }
      g.restore();
    }
    for (let i = 0; i < 120; i++) { g.fillStyle = 'rgba(40,45,52,' + (0.1 + Math.random() * 0.25) + ')'; g.beginPath(); g.arc(Math.random() * w, Math.random() * h, 0.5 + Math.random() * 1.2, 0, 7); g.fill(); }
  }, 512, 512, 3, 1),
  antler: () => canvasTex((g, w, h) => {
    g.fillStyle = '#e8e0cd'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 26; i++) { g.fillStyle = ['rgba(216,203,172,0.5)', 'rgba(242,236,224,0.6)', 'rgba(199,182,143,0.35)'][i % 3]; g.beginPath(); g.ellipse(Math.random() * w, Math.random() * h, 20 + Math.random() * 55, 10 + Math.random() * 28, Math.random() * 3, 0, 7); g.fill(); }
    for (let i = 0; i < 22; i++) { // winding marrow veins
      g.strokeStyle = 'rgba(160,138,96,' + (0.25 + Math.random() * 0.3) + ')'; g.lineWidth = 0.8 + Math.random() * 1.8; g.beginPath();
      let x = Math.random() * w, y = Math.random() * h; g.moveTo(x, y);
      for (let k = 0; k < 10; k++) { x += (Math.random() - 0.5) * 34; y += 12 + Math.random() * 16; g.quadraticCurveTo(x + (Math.random() - 0.5) * 18, y - 8, x, y); }
      g.stroke();
    }
    for (let i = 0; i < 420; i++) { g.fillStyle = 'rgba(150,130,95,' + (0.08 + Math.random() * 0.18) + ')'; g.beginPath(); g.arc(Math.random() * w, Math.random() * h, 0.5 + Math.random() * 1.6, 0, 7); g.fill(); }
  }, 512, 512, 3, 1),
  oak: () => canvasTex((g, w, h) => {
    g.fillStyle = '#5e3f24'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 34; i++) { // long grain
      g.strokeStyle = ['rgba(58,33,15,0.7)', 'rgba(139,95,56,0.5)', 'rgba(43,23,10,0.6)', 'rgba(160,116,70,0.35)'][i % 4];
      g.lineWidth = 1 + Math.random() * 3.5; g.beginPath();
      let y = Math.random() * h; g.moveTo(0, y);
      for (let x = 0; x <= w; x += 16) { y += (Math.random() - 0.5) * 5; g.lineTo(x, y); }
      g.stroke();
    }
    for (let i = 0; i < 3; i++) { // knots
      const kx = Math.random() * w, ky = Math.random() * h;
      for (let r = 14; r > 2; r -= 3) { g.strokeStyle = 'rgba(40,20,8,' + (0.25 + (14 - r) * 0.04) + ')'; g.lineWidth = 1.5; g.beginPath(); g.ellipse(kx, ky, r * 1.7, r, 0.3, 0, 7); g.stroke(); }
    }
    for (let i = 0; i < 160; i++) { g.fillStyle = 'rgba(26,13,5,' + (0.15 + Math.random() * 0.3) + ')'; g.fillRect(Math.random() * w, Math.random() * h, 1 + Math.random() * 4, 0.6 + Math.random() * 1.2); } // char flecks
  }, 512, 512, 4, 1),
  sandstone: () => canvasTex((g, w, h) => {
    g.fillStyle = '#122250'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 500; i++) { const b = Math.random(); g.fillStyle = b > 0.85 ? '#e4ecff' : b > 0.5 ? '#8fa7e8' : '#3a5090'; g.beginPath(); g.arc(Math.random() * w, Math.random() * h, 0.6 + Math.random() * 1.4, 0, 7); g.fill(); }
  }, 256, 256, 4, 1),
  redopal: () => canvasTex((g, w, h) => {
    g.fillStyle = '#9e2f1e'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 60; i++) { g.fillStyle = ['#c14a2e', '#7d2013', '#b03a24'][i % 3]; g.beginPath(); g.ellipse(Math.random() * w, Math.random() * h, 6 + Math.random() * 18, 4 + Math.random() * 10, Math.random() * 3, 0, 7); g.fill(); }
    for (let i = 0; i < 260; i++) { const b = Math.random(); g.fillStyle = b > 0.75 ? '#ffd9c4' : b > 0.4 ? '#ff8a5c' : '#ffb08f'; g.beginPath(); g.arc(Math.random() * w, Math.random() * h, 0.5 + Math.random() * 1.3, 0, 7); g.fill(); }
  }, 256, 256, 4, 1),
  cosmos: () => canvasTex((g, w, h) => {
    g.fillStyle = '#171633'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 40; i++) { g.fillStyle = ['#232055', '#101024', '#2a1e4a'][i % 3]; g.beginPath(); g.ellipse(Math.random() * w, Math.random() * h, 8 + Math.random() * 22, 5 + Math.random() * 12, Math.random() * 3, 0, 7); g.fill(); }
    for (let i = 0; i < 320; i++) { const b = Math.random(); g.fillStyle = b > 0.8 ? '#ffffff' : b > 0.55 ? '#7fe0ff' : b > 0.3 ? '#b48fff' : '#5a79e8'; g.beginPath(); g.arc(Math.random() * w, Math.random() * h, 0.4 + Math.random() * 1.2, 0, 7); g.fill(); }
  }, 256, 256, 4, 1),
  crushedmet: () => canvasTex((g, w, h) => {
    g.fillStyle = '#0f1013'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 200; i++) { // angular metallic shards in dark resin
      const x = Math.random() * w, y = Math.random() * h, r = 1.5 + Math.random() * 6;
      g.fillStyle = ['#9aa2ab', '#c0c7cf', '#6f7680', '#848c96'][i % 4];
      g.save(); g.translate(x, y); g.rotate(Math.random() * Math.PI); g.beginPath();
      const n = 3 + Math.floor(Math.random() * 2);
      for (let k = 0; k <= n; k++) { const a = (k / n) * Math.PI * 2; const rr = r * (0.5 + Math.random() * 0.7); k ? g.lineTo(Math.cos(a) * rr, Math.sin(a) * rr) : g.moveTo(Math.cos(a) * rr, Math.sin(a) * rr); }
      g.closePath(); g.fill(); g.restore();
    }
    for (let i = 0; i < 90; i++) { g.fillStyle = 'rgba(230,238,246,' + (0.3 + Math.random() * 0.5) + ')'; g.beginPath(); g.arc(Math.random() * w, Math.random() * h, 0.3 + Math.random() * 0.8, 0, 7); g.fill(); }
  }, 512, 512, 4, 1),
  brushfine: () => canvasTex((g, w, h) => {
    g.fillStyle = '#8a8a8a'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 500; i++) { const y = Math.random() * h; g.strokeStyle = 'rgba(' + (Math.random() > 0.5 ? '210,210,210' : '90,90,90') + ',' + (0.06 + Math.random() * 0.12) + ')'; g.lineWidth = 0.5 + Math.random() * 0.8; g.beginPath(); g.moveTo(0, y); g.lineTo(w, y + (Math.random() - 0.5) * 2); g.stroke(); }
  }, 512, 128, 2, 1),
  brushcoarse: () => canvasTex((g, w, h) => {
    g.fillStyle = '#858585'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 180; i++) { const y = Math.random() * h; g.strokeStyle = 'rgba(' + (Math.random() > 0.5 ? '225,225,225' : '55,55,55') + ',' + (0.15 + Math.random() * 0.3) + ')'; g.lineWidth = 1 + Math.random() * 2.4; g.beginPath(); g.moveTo(0, y); g.lineTo(w, y + (Math.random() - 0.5) * 4); g.stroke(); }
  }, 512, 128, 2, 1),
  carbon: () => canvasTex((g, w, h) => {
    const s = 32;
    for (let x = 0; x < w; x += s) for (let y = 0; y < h; y += s) {
      const alt = ((x + y) / s) % 2; g.fillStyle = alt ? '#26272b' : '#33353a'; g.fillRect(x, y, s, s);
      g.strokeStyle = alt ? '#1d1e21' : '#2a2c30'; g.lineWidth = 1;
      for (let k = 4; k < s; k += 6) { g.beginPath(); if (alt) { g.moveTo(x + k, y); g.lineTo(x + k, y + s); } else { g.moveTo(x, y + k); g.lineTo(x + s, y + k); } g.stroke(); }
    }
  }, 256, 256, 6, 2),
};
const METALS = {
  'Tungsten': { color: 0x585d66, rough: 0.32 },
  'Titanium': { color: 0x9aa0a8, rough: 0.38 },
  'Black Zirconium': { color: 0x26272a, rough: 0.45 },
  // tantalum reads a touch darker and bluer than titanium, and never takes a mirror polish
  'Tantalum': { color: 0x6f7378, rough: 0.44 },
  'Scottish Deer Antler': { tex: 'antler', color: 0xffffff, rough: 0.7, organic: true },
  'Whisky Barrel Oak': { tex: 'oak', color: 0xffffff, rough: 0.65, organic: true },
};
const METAL_INLAYS = { 'Brushed Black Metal': { color: 0x1c1d20, rough: 0.52 }, 'Brushed Titanium': { color: 0x8f949b, rough: 0.45 }, 'Brushed Gold': { color: 0xc9a24b, rough: 0.45 } };
const INLAY_TEX = { 'Muonionalusta Meteorite': 'meteorite', 'Scottish Deer Antler': 'antler', 'Whisky Barrel Oak': 'oak', 'Oak': 'oak', 'Starry Night (Blue Sandstone)': 'sandstone', 'Red Opal': 'redopal', 'Blue Opal': 'blueopal', 'Abalone': 'abalone', 'Green Opal & Abalone': 'greenopal', 'Galaxy (Sandstone & Meteorite)': 'cosmos', 'Crushed Meteorite in Resin': 'crushedmet', 'Forged Carbon Fibre': 'carbonblack', 'Carbon Fibre & Copper': 'carboncopper', 'Carbon Fibre & Gold': 'carbongold', 'Carbon Fibre & Silver': 'carbonsilver', 'Carbon Fibre & Rose Gold': 'carbonrosegold', 'Carbon Fibre & Blue': 'carbonblue', 'Moss Agate': 'mossagate' };
const SLEEVES = { 'Titanium sleeve': { color: 0x9aa0a8, rough: 0.35 }, 'Antler sleeve': { tex: 'antler', color: 0xffffff, rough: 0.7 }, 'Oak sleeve': { tex: 'oak', color: 0xffffff, rough: 0.65 } };

class RingViewer extends HTMLElement {
  static get observedAttributes() { return ['config']; }
  set config(v) { this._cfg = typeof v === 'string' ? JSON.parse(v) : v; if (this._ready) this.build(); }
  get config() { return this._cfg; }
  attributeChangedCallback(n, o, v) { if (v) this.config = v; }
  connectedCallback() {
    if (this._ready) return;
    try { this._boot(); } catch (err) {
      if (window.console) console.error('[fnd viewer]', err);
      this.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100%;padding:24px;text-align:center;font-family:Jost,sans-serif;font-size:13px;font-weight:300;line-height:1.6;color:#a29d90">The 3D preview could not start on this device.<br>Every option still works, and the summary lists your design in full.</div>';
    }
  }
  _boot() {
    // config assigned before upgrade lands as an own property that shadows the setter: adopt and clear it
    if (Object.prototype.hasOwnProperty.call(this, 'config')) { const pre = this.config; delete this.config; this._cfg = typeof pre === 'string' ? JSON.parse(pre) : pre; }
    this.style.display = 'block'; this.style.width = '100%';
    if (!this.clientHeight) this.style.minHeight = '260px';
    let renderer;
    try {
      renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true });
    } catch (e1) {
      // Second chance with everything optional turned off before giving up on the device.
      renderer = new THREE.WebGLRenderer({ antialias: false, alpha: true, preserveDrawingBuffer: true, powerPreference: 'low-power' });
    }
    this.renderer = renderer;
    const lowEnd = this._lowEnd = !renderer.capabilities.isWebGL2 || Math.min(screen.width, screen.height) <= 480;
    renderer.setPixelRatio(Math.min(devicePixelRatio, lowEnd ? 1.5 : 2));
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    this.appendChild(renderer.domElement);
    renderer.domElement.style.cssText = 'width:100%;height:100%;display:block;cursor:grab;touch-action:none';
    const scene = this.scene = new THREE.Scene();
    // STAGE, 21 Sep 2026. stage="light" puts the ring on a white set instead of the dark one: a
    // bright surround for the metal and the stones to reflect, and a shadow pool instead of a pool
    // of light. Default is unchanged, so nothing on the site moves unless the attribute is set.
    const litStage = (this.getAttribute('stage') || '') === 'light';
    this._litStage = litStage;
    // relief="on" drives the textured finishes from a NORMAL map generated out of the same finish
    // photo, instead of painting that photo on flat. Off by default: it changes how every textured
    // finish looks, so it is opt-in until the merchant has chosen.
    this._relief = (this.getAttribute('relief') || '') === 'on';
    const cam = this.cam = new THREE.PerspectiveCamera(32, 1, 0.5, 60);
    cam.position.set(0, 8, 34); cam.lookAt(0, 0, 0);
    // DEPTH PRECISION, 20 Sep 2026: the overlay strips (face texture, zone, groove, inlay, metal
    // line) are stacked 0.003-0.015 units apart on a band ~11.6 units in radius, seen from ~13-31
    // units away. A perspective depth buffer spends nearly all its resolution just behind the NEAR
    // plane, so the original 0.05/400 range left the depth quantum out at the ring far coarser than
    // the gaps between the layers: the strips tied in the buffer and whichever won flickered frame
    // to frame. 16-bit depth (common on lower-spec mobile) made it constant, 24-bit desktop
    // marginal, and zooming in appeared to fix it because a nearer camera shrinks the quantum.
    // near/far now track the actual ring distance, worth ~100x precision where it matters.
    // The margin comes from the MEASURED geometry radius (the same _fitR the framing maths uses),
    // not a constant: a hardcoded margin clipped the ring's front face at small fitted distances.
    let lastDist = 0;
    // `force` skips the distance memo. The memo exists so the render loop is cheap, but it means a
    // caller that changes near/far behind this function's back (the before/after toggle in
    // test-render-layers.html did exactly that) can never get the range recomputed at an unchanged
    // camera distance - the guard fires every frame and the wrong range sticks until a zoom or
    // resize. Anything that writes cam.near/cam.far directly must call this with force.
    this._depth = (force) => {
      const d = cam.position.length();
      if (!force && Math.abs(d - lastDist) < 0.25) return;
      lastDist = d;
      const r = (this._fitR || 11.6);
      cam.near = Math.max(0.1, d - r * 1.06);
      cam.far = d + r * 1.2;
      cam.updateProjectionMatrix();
    };
    // procedural studio environment for metal reflections
    const env = new THREE.Scene();
    const mk = (w, h, x, y, z, c, i) => { const m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({ color: c })); m.position.set(x, y, z); m.lookAt(0, 0, 0); m.material.color.multiplyScalar(i); env.add(m); };
    env.background = new THREE.Color(litStage ? 0xf4f2ee : 0x999999);
    if (litStage) {
      // A WHITE SET. Not just brighter panels: the whole surround is light, so every facet of a
      // stone and every curve of the metal has something to reflect from any angle. That is the
      // thing Auronia's shoot buys, and no material setting substitutes for it.
      mk(34, 34, 0, 20, 0, 0xffffff, 6.5); mk(28, 18, -18, 4, 10, 0xfffaf0, 4.6); mk(28, 18, 18, 2, -8, 0xf0f5ff, 4.2);
      mk(34, 16, 0, -15, 5, 0xffffff, 3.2); mk(24, 24, 0, 6, -20, 0xffffff, 3.6); mk(30, 30, 0, 0, 24, 0xffffff, 2.8);
      // BLACK FLAGS. A surround that is white in every direction leaves metal with nothing dark to
      // reflect, so it washes out to a flat pale grey. Product photographers hang black cards on a
      // white set for exactly this reason: the dark reflections are what give the metal its form.
      mk(16, 26, -15, -3, 14, 0x000000, 1); mk(13, 22, 16, -5, 12, 0x000000, 1);
    } else {
      mk(30, 30, 0, 20, 0, 0xffffff, 3.5); mk(25, 14, -18, 4, 10, 0xfff4e0, 2.6); mk(25, 14, 18, 2, -8, 0xdde6ff, 2.2); mk(30, 12, 0, -15, 5, 0xcccccc, 1.4); mk(20, 20, 0, 6, -20, 0xffffff, 1.8);
    }
    try {
      const pmrem = new THREE.PMREMGenerator(renderer);
      scene.environment = pmrem.fromScene(env).texture;
      pmrem.dispose();
    } catch (e2) {
      // No reflection map on this GPU: lean on the lights below instead of failing the whole viewer.
      if (window.console) console.warn('[fnd viewer] no environment map', e2);
      scene.add(new THREE.AmbientLight(0xffffff, 0.55));
    }
    scene.add(new THREE.HemisphereLight(0xffffff, 0x555566, 0.9));
    const key = new THREE.DirectionalLight(0xffffff, 2.2); key.position.set(8, 14, 10); scene.add(key);
    const fill = new THREE.DirectionalLight(0xfff0dd, 0.8); fill.position.set(-10, -6, -8); scene.add(fill);
    const group = this.group = new THREE.Group(); scene.add(group);
    group.rotation.set(0.35, 0, 0);
    // GROUNDING, 21 Sep 2026. A ring floating in a vignette reads as CG however good the metal is;
    // what sells a product render is that the object is plainly sitting on something. Two flat discs
    // in WORLD space, and deliberately NOT inside `group`: that group rotates under the pointer, and
    // its Box3 drives both the framing and the near/far range, so a floor in there would shove the
    // ring away from the camera and blow out the depth precision the 20 Sep work bought.
    const ground = this._ground = new THREE.Group(); scene.add(ground);
    (() => {
      const cv = document.createElement('canvas'); cv.width = cv.height = 256;
      const cx = cv.getContext('2d');
      const rg = cx.createRadialGradient(128, 128, 0, 128, 128, 128);
      // The stage is near-black and the camera sits only ~13 degrees above the floor, so the pool
      // is read almost edge-on: it has to be a good deal brighter than it would be on a white set.
      if (litStage) {
        // On white, the ring needs a shadow to sit in rather than a pool of light to sit on.
        rg.addColorStop(0, 'rgba(94,90,84,0.42)');
        rg.addColorStop(0.32, 'rgba(108,103,96,0.22)');
        rg.addColorStop(0.66, 'rgba(118,113,106,0.07)');
        rg.addColorStop(1, 'rgba(118,113,106,0)');
      } else {
        rg.addColorStop(0, 'rgba(255,251,244,0.62)');
        rg.addColorStop(0.30, 'rgba(255,249,240,0.34)');
        rg.addColorStop(0.62, 'rgba(255,248,238,0.10)');
        rg.addColorStop(1, 'rgba(255,248,238,0)');
      }
      cx.fillStyle = rg; cx.fillRect(0, 0, 256, 256);
      const t = new THREE.CanvasTexture(cv);
      const pool = new THREE.Mesh(new THREE.CircleGeometry(1, 64), new THREE.MeshBasicMaterial({ map: t, transparent: true, depthWrite: false }));
      pool.rotation.x = -Math.PI / 2; pool.renderOrder = -2;
      ground.add(pool);
    })();
    // The cast shadow is real, not a blob, but ONLY the floor receives it and only the base band
    // casts (see fitToGroup). Nothing self-shadows, so none of the coplanar strips can acne.
    if (!lowEnd) {
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      key.position.normalize().multiplyScalar(44); // same direction, far enough back to frame the ring
      key.castShadow = true;
      key.shadow.mapSize.set(1024, 1024);
      key.shadow.camera.near = 12; key.shadow.camera.far = 92;
      key.shadow.camera.left = -18; key.shadow.camera.right = 18;
      key.shadow.camera.top = 18; key.shadow.camera.bottom = -18;
      key.shadow.normalBias = 0.3;
      const catcher = new THREE.Mesh(new THREE.CircleGeometry(1, 64), new THREE.ShadowMaterial({ opacity: litStage ? 0.3 : 0.55, depthWrite: false }));
      catcher.rotation.x = -Math.PI / 2; catcher.position.y = 0.01; catcher.receiveShadow = true; catcher.renderOrder = -1;
      ground.add(catcher);
    }
    this.textures = {};
    // drag rotate + idle autorotate
    let drag = null, idle = 0;
    const el = renderer.domElement;
    // Zoom: pinch on touch, wheel on desktop. Kept modest on purpose - it is for looking closely at
    // a groove or an inlay edge, not for free camera work. baseDist is whatever resize() computed,
    // so zoom survives a resize and an orientation change.
    let baseDist = 26, zoom = 1;
    // FREE ROTATION, 21 Sep 2026. Accumulating into rotation.x/.y is a two-axis gimbal: past a
    // quarter turn the horizontal drag starts working backwards and the ring can never be turned
    // over to look at the back of the band. The drag now builds a quaternion from the pointer delta
    // and applies it on the LEFT of the current orientation, i.e. about the WORLD axes the finger
    // implies, which is what makes a trackball feel right from any starting pose.
    // THE SURFACE FOLLOWS THE FINGER, 22 Sep 2026. Merchant: hard to get the ring where he wants
    // it, on desktop and mobile. Three causes, all fixed here:
    // 1. A FIXED 0.01 rad per pixel ignored how big the ring is on screen, so the same swipe turned
    //    a phone-sized ring far further than a desktop one and nothing stayed under the finger. The
    //    rate is now 1 / (the band's on-screen radius in px), which is exactly the rate at which a
    //    point on the front of the band moves - so the metal you grab tracks the pointer.
    // 2. The axes were WORLD X/Y, but the camera sits above the ring looking down, so a sideways
    //    drag turned the band about a tilted axis. The axes now come from the camera itself.
    // 3. The idle spin resumed 1.5s after letting go and carried the ring away from the angle just
    //    chosen. Once the customer has turned it themselves, it stays where they put it.
    // A short fling on release keeps a quick flick feeling physical, and decays in under a second.
    const dq = new THREE.Quaternion();
    const camR = new THREE.Vector3(), camU = new THREE.Vector3(), axisD = new THREE.Vector3();
    let fling = null, lastMove = null, turned = 0;
    const pxRadius = () => {
      const h = el.clientHeight || 1;
      const r = this._locR || 11.25;
      return Math.max(50, (r / (cam.position.length() * Math.tan(cam.fov * Math.PI / 360))) * h / 2);
    };
    const rateRot = (dx, dy) => {
      const len = Math.hypot(dx, dy);
      if (!len) return;
      const ang = len / pxRadius();
      camR.setFromMatrixColumn(cam.matrixWorld, 0);
      camU.setFromMatrixColumn(cam.matrixWorld, 1);
      axisD.copy(camR).multiplyScalar(dy).addScaledVector(camU, dx).normalize();
      group.quaternion.premultiply(dq.setFromAxisAngle(axisD, ang));
      lastMove = { axis: axisD.clone(), ang, t: performance.now() };
      turned += ang;
      if (turned > 0.05) this._userTurned = true;
    };
    // GRAB, NOT TRACKBALL, 22 Sep 2026. Merchant: the rotation still did not feel like pulling the
    // ring. A trackball turns about the centre, so the FRONT follows the pointer - but what a
    // customer grabs is often the inside of the far wall (the FOUNDORIA mark), and that moves the
    // OPPOSITE way to the drag. Now the point under the pointer is picked on pointerdown and held
    // under it: a sphere through that point, near or far side as it was hit, and each move
    // rotates the ring so the grabbed point lands under the new pointer position.
    const ray = new THREE.Raycaster(), ndc = new THREE.Vector2();
    const gc = new THREE.Vector3(), tmpO = new THREE.Vector3(), gp = new THREE.Vector3();
    const toNdc = (cx, cy) => { const b = el.getBoundingClientRect(); return ndc.set(((cx - b.left) / b.width) * 2 - 1, -((cy - b.top) / b.height) * 2 + 1); };
    const sphereAt = (cx, cy, g, out) => {
      ray.setFromCamera(toNdc(cx, cy), cam);
      const o = ray.ray.origin, d = ray.ray.direction;
      tmpO.subVectors(o, gc);
      const b = tmpO.dot(d), disc = b * b - (tmpO.lengthSq() - g.r * g.r);
      if (disc < 0) return out.copy(o).addScaledVector(d, -b).sub(gc);
      return out.copy(o).addScaledVector(d, g.far ? -b + Math.sqrt(disc) : -b - Math.sqrt(disc)).sub(gc);
    };
    const beginGrab = (cx, cy) => {
      group.getWorldPosition(gc);
      ray.setFromCamera(toNdc(cx, cy), cam);
      const hit = ray.intersectObjects(group.children, true)[0];
      const g = { r: this._locR || 11.25, far: false, v: new THREE.Vector3() };
      if (hit) {
        g.r = Math.max(1, hit.point.distanceTo(gc));
        g.far = hit.distance > -tmpO.subVectors(ray.ray.origin, gc).dot(ray.ray.direction);
      }
      sphereAt(cx, cy, g, g.v).normalize();
      return g;
    };
    const moveGrab = (g, cx, cy) => {
      sphereAt(cx, cy, g, gp).normalize();
      dq.setFromUnitVectors(g.v, gp);
      const ang = 2 * Math.acos(Math.min(1, Math.abs(dq.w)));
      g.v.copy(gp);
      if (ang < 1e-6) return;
      group.quaternion.premultiply(dq);
      const s = Math.sin(ang / 2) * (dq.w < 0 ? -1 : 1);
      lastMove = { axis: new THREE.Vector3(dq.x / s, dq.y / s, dq.z / s).normalize(), ang, t: performance.now() };
      turned += ang;
      if (turned > 0.05) this._userTurned = true;
    };
    // TWO FINGERS POSITION THE RING: move them together to turn it, twist them to roll it about
    // the line of sight, spread them to zoom - all at once, as in any photo or map app.
    const twistAng = () => { const p = [...pointers.values()]; return Math.atan2(p[1].y - p[0].y, p[1].x - p[0].x); };
    const centroid = () => { const p = [...pointers.values()]; return { x: (p[0].x + p[1].x) / 2, y: (p[0].y + p[1].y) / 2 }; };
    this._flingStep = () => {
      if (!fling || drag) return;
      group.quaternion.premultiply(dq.setFromAxisAngle(fling.axis, fling.w));
      fling.w *= 0.9;
      if (fling.w < 0.0008) fling = null;
    };
    // The idle turn is about the band's OWN axis (right-multiply = local), so the ring spins in
    // place as it always has rather than tumbling.
    const spinQ = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), 0.004);
    const axisV = new THREE.Vector3();
    const ZMIN = 0.5, ZMAX = 1.2;
    const pointers = new Map();
    const applyZoom = () => { cam.position.setLength(baseDist * zoom); this._depth(); };
    let pinch = null;
    const spread = () => {
      const p = [...pointers.values()];
      return Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
    };
    el.addEventListener('pointerdown', e => {
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      try { el.setPointerCapture(e.pointerId); } catch (_) {}
      if (pointers.size === 2) { drag = null; fling = null; pinch = { d: spread(), z: zoom, a: twistAng(), c: centroid() }; }
      else if (pointers.size === 1) { drag = beginGrab(e.clientX, e.clientY); fling = null; lastMove = null; el.style.cursor = 'grabbing'; }
    });
    el.addEventListener('pointermove', e => {
      if (pointers.has(e.pointerId)) pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pinch && pointers.size >= 2) {
        const d = spread();
        if (d > 0 && pinch.d > 0) { zoom = Math.min(ZMAX, Math.max(ZMIN, pinch.z * (pinch.d / d))); applyZoom(); }
        const a = twistAng();
        let da = a - pinch.a;
        if (da > Math.PI) da -= 2 * Math.PI; else if (da < -Math.PI) da += 2 * Math.PI;
        if (Math.abs(da) > 1e-4) {
          // Screen y runs down, so a clockwise twist is a positive da, and a clockwise turn as the
          // viewer sees it is a NEGATIVE rotation about the axis pointing at the viewer.
          group.getWorldPosition(gc);
          axisD.subVectors(cam.position, gc).normalize();
          group.quaternion.premultiply(dq.setFromAxisAngle(axisD, -da));
          turned += Math.abs(da); if (turned > 0.05) this._userTurned = true;
        }
        pinch.a = a;
        const c2 = centroid();
        rateRot(c2.x - pinch.c.x, c2.y - pinch.c.y);
        pinch.c = c2;
        idle = 0;
        return;
      }
      if (!drag) return;
      moveGrab(drag, e.clientX, e.clientY); idle = 0;
    });
    const lift = e => {
      pointers.delete(e.pointerId);
      // Lifting one of two fingers hands straight back to a one-finger grab, so there is no dead
      // moment where the remaining finger does nothing.
      if (pointers.size < 2 && pinch) {
        pinch = null;
        if (pointers.size === 1) { const p = [...pointers.values()][0]; drag = beginGrab(p.x, p.y); lastMove = null; }
      }
      if (!pointers.size) {
        if (drag && lastMove && performance.now() - lastMove.t < 70 && lastMove.ang > 0.004)
          fling = { axis: lastMove.axis, w: Math.min(0.12, lastMove.ang) };
        drag = null; el.style.cursor = 'grab';
      }
    };
    el.addEventListener('pointerup', lift);
    el.addEventListener('pointercancel', lift);
    // Wheel over the ring zooms. The left column is sticky and has nothing of its own to scroll,
    // so taking the wheel there is what a customer expects; the real fault behind "the frame is too
    // tight" was the framing itself (see halfExtent below), not the gesture.
    el.addEventListener('wheel', e => {
      e.preventDefault();
      zoom = Math.min(ZMAX, Math.max(ZMIN, zoom * (1 + e.deltaY * 0.0012)));
      applyZoom(); idle = 0;
    }, { passive: false });
    // Double tap / double click snaps back out, so a customer can never get stranded up close.
    el.addEventListener('dblclick', () => { zoom = 1; applyZoom(); idle = 0; });
    // AUTO-ROTATE TOGGLE, 22 Sep 2026. The slow idle spin is back, but it no longer fights the
    // customer: the moment they turn the ring themselves the spin switches OFF and this button shows
    // it, so the ring stays at the angle they chose (the 19:30 complaint) and they can see exactly
    // how to get the spin back. Tapping it resumes from wherever the ring is. Drawn by the viewer
    // itself so no theme edit is needed; controls="none" hides it (ad capture, comparison pages).
    this._spinOn = !this._noSpin;
    const spinBtn = this._spinBtn = document.createElement('button');
    spinBtn.type = 'button';
    // 24 Sep 2026: on a narrow stage (phones) the full pill sat over the ring, so it collapses to a
    // 30px round icon tucked into the corner. The BUTTON stays 44x44 for the tap target; only the
    // visible disc inside it is small, so the hit area overlaps empty corner, not the ring.
    const spinFull = 'position:absolute;right:10px;bottom:10px;z-index:2;display:flex;align-items:center;gap:8px;min-height:44px;padding:0 14px;background:rgba(18,17,16,.55);border:1px solid rgba(162,157,144,.35);border-radius:22px;color:#c9c3b6;font:400 11px/1 Jost,sans-serif;letter-spacing:.14em;text-transform:uppercase;cursor:pointer;-webkit-tap-highlight-color:transparent';
    const spinMini = 'position:absolute;right:2px;bottom:2px;z-index:2;display:flex;align-items:center;justify-content:center;width:44px;height:44px;padding:0;background:transparent;border:0;cursor:pointer;-webkit-tap-highlight-color:transparent';
    const paintSpin = () => {
      const on = this._spinOn;
      const mini = (this.clientWidth || innerWidth) < 600;
      spinBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      spinBtn.setAttribute('aria-label', on ? 'Auto-rotate on' : 'Auto-rotate off');
      spinBtn.title = on ? 'Auto-rotate on' : 'Auto-rotate off';
      if (mini) {
        spinBtn.style.cssText = spinMini;
        const c = on ? '#c9a24b' : '#a29d90';
        spinBtn.innerHTML = '<span style="display:flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:50%;background:rgba(18,17,16,.55);border:1px solid ' + (on ? 'rgba(201,162,75,.7)' : 'rgba(162,157,144,.35)') + ';box-sizing:border-box"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="' + c + '" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12a8 8 0 1 1-2.34-5.66"/><path d="M20 4v5h-5"/></svg></span>';
      } else {
        spinBtn.style.cssText = spinFull;
        spinBtn.innerHTML = '<span style="width:7px;height:7px;border-radius:50%;background:' + (on ? '#c9a24b' : 'transparent') + ';border:1px solid ' + (on ? '#c9a24b' : '#a29d90') + '"></span>' + (on ? 'Auto-rotate on' : 'Auto-rotate off');
      }
    };
    addEventListener('resize', () => paintSpin());
    this._paintSpin = paintSpin;
    spinBtn.addEventListener('click', () => {
      this._spinOn = !this._spinOn;
      this._userTurned = !this._spinOn;
      turned = 0; idle = 60;
      paintSpin();
    });
    paintSpin();
    if (getComputedStyle(this).position === 'static') this.style.position = 'relative';
    if ((this.getAttribute('controls') || '') !== 'none' && !this._noSpin) this.appendChild(spinBtn);
    // fit() takes an EXPLICIT box rather than measuring the canvas, so the high-res still in shot()
    // can reuse this exact framing maths at a size the canvas has never been. exact=true drops the
    // defensive clamps below: they exist to survive a degenerate canvas measurement on screen, but
    // an export box is known-good, and in a very tall frame the 1.45x cap would crop the ring.
    const fit = (w, h, exact) => {
      renderer.setSize(w, h, false); cam.aspect = w / h;
      // FILL THE FRAME. The ring is fitted to whichever dimension is tighter - in the tall desktop
      // column that is the WIDTH, so a generous margin made the ring small with a lot of empty
      // space above and below it. 1.1 leaves a hair of clearance and no more; zoom does the rest.
      const halfExtent = (this._fitR || 11.3) * 1.08;
      const vFov = THREE.MathUtils.degToRad(cam.fov / 2);
      // base = the distance at which the ring exactly fills the frame's HEIGHT. Dividing by the
      // aspect fits a narrow frame's WIDTH instead - but a degenerate measurement (a canvas that
      // reports itself far taller than it looks) makes that divisor tiny and throws the camera
      // hundreds of units back, which is exactly the "tiny ring in a sea of black" symptom. So the
      // aspect is clamped to sane bounds AND the result is capped at 1.45x base.
      const base = halfExtent / Math.tan(vFov);
      const a = exact ? (cam.aspect || 1) : Math.min(2.5, Math.max(0.5, cam.aspect || 1));
      // NO ABSOLUTE FLOOR. There used to be a Math.max(..., 26) here, written when the fit assumed a
      // ring ~11.3 units across. The geometry is in fact a few units across, so the required
      // distance is nowhere near 26 and that floor pinned the camera far too far back - which is
      // why every margin and aspect change left the ring stubbornly small. Bounds are now relative
      // to the fitted distance, never absolute.
      baseDist = exact
        ? Math.max(1, base / Math.min(1, a))
        : Math.max(1, Math.min(base / Math.min(1, a), base * 1.45));
      applyZoom();
      cam.updateProjectionMatrix();
    };
    const resize = () => {
      const w = renderer.domElement.clientWidth || this.clientWidth || 300;
      const h = renderer.domElement.clientHeight || this.clientHeight || 300;
      fit(w, h);
    };
    this._fit = fit; this._resize = resize;
    var ro = new ResizeObserver(resize); ro.observe(this); ro.observe(renderer.domElement); resize();
    // SELF-HEALING SIZE. The canvas is CSS-sized to 100% of this element, so if the element's box
    // changes without the observer having fired yet (sticky column settling, a vh change, fonts
    // landing) the drawing buffer is stretched to fit - the ring looks magnified, soft and clipped
    // rather than re-fitted. Comparing the canvas' real box to the buffer each frame costs nothing
    // and makes a missed observation impossible.
    let lastW = 0, lastH = 0, lastKids = -1;
    const fitToGroup = () => {
      // MEASURE IN THE CANONICAL POSE, 21 Sep 2026. Box3.setFromObject returns an AXIS-ALIGNED box,
      // so a tilted ring's box swings by about a third as the idle spin turns it. That was harmless
      // while this ran once at load; now that it runs on every rebuild it would re-fit the camera to
      // whatever angle the ring happened to be at, and the ring would visibly jump size on a change
      // that swapped nothing but a material. Rotation is parked at the pose the framing was tuned
      // against (x 0.35, the load pose) for the measurement and restored immediately, so the figure
      // is the same whatever the customer is doing with the ring. _fitR also feeds _depth(), so a
      // stable figure keeps the 20 Sep near/far range stable too.
      const rot = group.quaternion.clone();
      group.rotation.set(0.35, 0, 0); group.updateMatrixWorld(true);
      const box = new THREE.Box3().setFromObject(group);
      group.quaternion.copy(rot); group.updateMatrixWorld(true);
      if (box.isEmpty()) return;
      const sph = box.getBoundingSphere(new THREE.Sphere());
      if (sph.radius > 0.5) { this._fitR = sph.radius; resize(); }
      // LOCAL extents for the contact height. Same trap as the framing above: Box3.setFromObject
      // rotates each mesh's local CUBOID, not its vertices, so an AABB taken while the ring spins
      // reports a lowest point that swings by well over a millimetre on a ring that is axisymmetric
      // and never actually moves. Measured unrotated here, once per rebuild, and turned into the
      // true contact point analytically in the loop.
      group.rotation.set(0, 0, 0); group.updateMatrixWorld(true);
      const loc = new THREE.Box3().setFromObject(group);
      group.quaternion.copy(rot); group.updateMatrixWorld(true);
      this._locR = Math.max(Math.abs(loc.min.x), Math.abs(loc.max.x), Math.abs(loc.min.z), Math.abs(loc.max.z));
      this._locH = Math.max(Math.abs(loc.min.y), Math.abs(loc.max.y));
      // Cast from the band only. Every overlay strip carries a non-zero polygonOffsetUnits (the
      // 20 Sep depth work), and they share the band's silhouette anyway, so casting from them all
      // would buy nothing and cost a dozen extra draws in the shadow pass on a phone.
      group.traverse((o) => { if (o.isMesh) { o.castShadow = !o.material || !o.material.polygonOffsetUnits; o.receiveShadow = false; } });
      if (this._ground) this._ground.scale.setScalar(Math.max(8, sph.radius * 0.92));
    };
    const loop = () => {
      this._raf = requestAnimationFrame(loop);
      this._depth();
      if (group.children.length !== lastKids || this._rebuilt) { this._rebuilt = false; lastKids = group.children.length; fitToGroup(); }
      this._flingStep();
      if (this._userTurned && this._spinOn) { this._spinOn = false; this._paintSpin(); }
      if (!drag && !this._noSpin && this._spinOn) { idle++; if (idle > 90) group.quaternion.multiply(spinQ); }
      // The floor sits at the ring's true lowest point. For an axisymmetric band of outer radius R
      // and half width h whose axis points a, that is -(h|a.y| + R.sqrt(1 - a.y^2)) - exact for ANY
      // orientation now that the ring can be turned over, and still blind to the spin about a.
      if (this._ground && this._locR) {
        axisV.set(0, 1, 0).applyQuaternion(group.quaternion);
        const ay = Math.min(1, Math.abs(axisV.y));
        const want = -(this._locH * ay + this._locR * Math.sqrt(Math.max(0, 1 - ay * ay))) - 0.12;
        const have = this._ground.position.y;
        this._ground.position.y = Math.abs(want - have) > 2 ? want : have + (want - have) * 0.25;
      }
      renderer.render(scene, cam);
    };
    loop();
    this._ready = true;
    if (this.getAttribute('config')) this.config = this.getAttribute('config');
    if (this._cfg) this.build();
    // ?fndshot=1 turns the viewer into an image exporter for marketing stills. Off by default and
    // invisible to customers; the idle autorotate is suspended so a posed ring stays posed.
    if (/[?&]fndshot=1/.test(location.search)) { this._noSpin = true; this._spinOn = false; this._spinBtn.remove(); this._shotBar(); }
  }
  // HIGH-RES STILL. The on-screen canvas is only a few hundred CSS px, so a screen grab of it is far
  // too small and soft for a promo tile - but WebGL will render at any size the GPU allows. This
  // re-fits the camera to the requested box, renders ONE frame at pixel ratio 1 and returns a PNG
  // data URL with a TRANSPARENT background (the renderer is alpha:true and the scene has no
  // background, so the ring drops straight onto any colour). The live viewer is fully restored
  // afterwards: size, pixel ratio and framing. Needs preserveDrawingBuffer, which _boot already sets.
  shot(opts) {
    const o = opts || {};
    const w = Math.max(64, Math.min(4096, Math.round(o.w || 1600)));
    const h = Math.max(64, Math.min(4096, Math.round(o.h || w * 1.375)));
    const r = this.renderer;
    const pr = r.getPixelRatio();
    r.setPixelRatio(1);
    // The still is a transparent cut-out for marketing tiles, so the floor and its shadow come out.
    const hadGround = this._ground ? this._ground.visible : false;
    if (this._ground) this._ground.visible = false;
    this._fit(w, h, true);
    r.render(this.scene, this.cam);
    const url = r.domElement.toDataURL('image/png');
    if (this._ground) this._ground.visible = hadGround;
    r.setPixelRatio(pr);
    this._resize();
    r.render(this.scene, this.cam);
    return url;
  }
  save(opts) {
    const o = opts || {};
    const a = document.createElement('a');
    a.href = this.shot(o);
    a.download = o.name || ('foundoria-ring-' + (o.w || 1600) + 'x' + (o.h || Math.round((o.w || 1600) * 1.375)) + '.png');
    document.body.appendChild(a); a.click(); a.remove();
  }
  _shotBar() {
    if (this._bar) return;
    this.style.position = 'relative';
    const bar = this._bar = document.createElement('div');
    bar.style.cssText = 'position:absolute;left:8px;bottom:8px;z-index:9;display:flex;flex-wrap:wrap;gap:6px;font-family:Jost,sans-serif';
    [['Tile 1600\u00d72200', 1600, 2200], ['Tall tile 1400\u00d73550', 1400, 3550], ['Banner 2400\u00d71200', 2400, 1200], ['Square 2000\u00d72000', 2000, 2000]].forEach(p => {
      const b = document.createElement('button');
      b.type = 'button';
      b.textContent = p[0];
      b.style.cssText = 'padding:7px 11px;border:0;background:rgba(28,27,25,.82);color:#f4f1ea;font-size:11px;letter-spacing:.08em;text-transform:uppercase;font-weight:500;cursor:pointer';
      b.addEventListener('click', e => { e.preventDefault(); this.save({ w: p[1], h: p[2] }); });
      bar.appendChild(b);
    });
    this.appendChild(bar);
  }
  disconnectedCallback() { cancelAnimationFrame(this._raf); }
  tex(name) {
    if (!this.textures[name]) {
      if (PHOTOS[name]) {
        const [url, rx, ry, srgb] = PHOTOS[name];
        const t = new THREE.TextureLoader().load(A(url), undefined, undefined, () => { if (TEX[name]) this.textures[name] = TEX[name](); });
        t.wrapS = t.wrapT = THREE.RepeatWrapping; t.repeat.set(rx, ry);
        if (srgb) t.colorSpace = THREE.SRGBColorSpace;
        this.textures[name] = this.sharpen(t);
      } else this.textures[name] = this.sharpen(TEX[name]());
    }
    return this.textures[name];
  }
  // TEXTURE SHIMMER, 20 Sep 2026: a hammer or brushed relief map is 1-2k wide and lands on a strip
  // a few screen pixels tall. Without anisotropic filtering the GPU minifies it badly, so the
  // pattern aliases and CRAWLS as the ring idles - the other half of "the lines flicker unless you
  // zoom in". Mipmapping fixes the shimmer; the depth work in _boot fixes the layer fighting. Both
  // were in play, which is why it looked like one bug on textured faces under a coloured line.
  sharpen(t) {
    if (!t || t._fndSharp) return t;
    t._fndSharp = true;
    t.generateMipmaps = true;
    t.minFilter = THREE.LinearMipmapLinearFilter;
    t.magFilter = THREE.LinearFilter;
    try { t.anisotropy = Math.min(8, this.renderer.capabilities.getMaxAnisotropy()); } catch (e) {}
    // ONLY flag an upload when there is actually an image. tex() calls this on the texture returned
    // by TextureLoader.load() the same tick, before the file has arrived, and an unconditional
    // needsUpdate made the renderer try to upload an imageless texture every frame until it did -
    // "Texture marked for update but no image data found" on repeat in the customer's console. The
    // filter and anisotropy properties are read at upload time, so the loader's own onLoad flag is
    // enough for the photo maps.
    if (t.image && t.image.width) t.needsUpdate = true;
    return t;
  }
  // Scale a lathe's V coordinate so a NARROW strip shows the pattern at the same physical size as
  // the wide face beside it. 20 Sep 2026, second pass: this replaces a scaleTex() that cloned the
  // map and set its repeat. Every relief map matchFace can reach is an async PHOTO, and tex()
  // passes no onLoad, so TextureLoader only ever re-flags the ORIGINAL texture: a clone taken
  // before the image arrived shared the source but nothing re-flagged it, its one needsUpdate was
  // consumed by a failed upload, and the matched line stayed untextured for the whole session on a
  // cold load. Scaling UVs touches only this geometry, so there is no second texture, no cache and
  // no race at all. A lathe's V runs 0..1 up the strip, so multiplying it by the strip's share of
  // the face gives exactly the repeat a full-width strip would have had over that distance.
  scaleUV(geo, k) {
    const uv = geo.attributes.uv;
    if (!uv || !(k > 0)) return geo;
    for (let i = 0; i < uv.count; i++) uv.setY(i, uv.getY(i) * k);
    uv.needsUpdate = true;
    return geo;
  }
  // A NORMAL MAP BUILT FROM THE FINISH PHOTO WE ALREADY HAVE. Sobel on the image's luminance gives
  // the slope at every texel, which is what a normal map is. Starts as flat blue (128,128,255) and
  // is filled in when the photo arrives, so there is no clone of a half-loaded texture and no race
  // - the 20 Sep matched-line bug was exactly that mistake.
  normalFrom(name, strength, flip) {
    const key = 'nrm:' + name + (flip ? ':flip' : '');
    if (this.textures[key]) return this.textures[key];
    const p = PHOTOS[name];
    if (!p) return null;
    const S = 256;
    const cv = document.createElement('canvas'); cv.width = cv.height = S;
    const cx = cv.getContext('2d', { willReadFrequently: true });
    cx.fillStyle = 'rgb(128,128,255)'; cx.fillRect(0, 0, S, S);
    const t = new THREE.CanvasTexture(cv);
    t.wrapS = t.wrapT = THREE.RepeatWrapping;
    // THE RELIEF MUST TILE AT THE PHOTO'S OWN RATE. Coarser measured as more different from the
    // flat build, and was wrong: the dents then describe a different pattern from the grain, the
    // two scales fight, and the hammering stops being legible (the merchant's read, 21 Sep 2026).
    // Mirrored zones flip V, and the green channel's sign goes with it.
    t.repeat.set(p[1], flip ? -p[2] : p[2]);
    this.sharpen(t);
    this.photoBitmap(name).then((img) => {
      if (!img) return;
      cx.drawImage(img, 0, 0, S, S);
      const src = cx.getImageData(0, 0, S, S).data;
      const lum = new Float32Array(S * S);
      for (let i = 0; i < S * S; i++) lum[i] = (src[i * 4] * 0.299 + src[i * 4 + 1] * 0.587 + src[i * 4 + 2] * 0.114) / 255;
      const out = cx.createImageData(S, S), o = out.data;
      const at = (x, y) => lum[((y + S) % S) * S + ((x + S) % S)];
      // AUTO-GAIN. The relief photos differ wildly in contrast, and a fixed multiplier gave one
      // finish a strong surface and the next one almost none: the first build produced normals
      // deviating by 0.08, which is no surface at all. Measure the steepest slope in the image and
      // scale everything so that one lands near 0.8, and every finish gets real relief.
      const gx = new Float32Array(S * S), gy = new Float32Array(S * S);
      let peak = 1e-6;
      for (let y = 0; y < S; y++) {
        for (let x = 0; x < S; x++) {
          const i = y * S + x;
          gx[i] = at(x + 1, y) - at(x - 1, y);
          gy[i] = at(x, y + 1) - at(x, y - 1);
          const m = Math.max(Math.abs(gx[i]), Math.abs(gy[i]));
          if (m > peak) peak = m;
        }
      }
      const gain = (strength || 1) * 0.8 / peak;
      for (let y = 0; y < S; y++) {
        for (let x = 0; x < S; x++) {
          const i = y * S + x;
          const nx = -gx[i] * gain, ny = -gy[i] * gain * (flip ? -1 : 1);
          const l = Math.hypot(nx, ny, 1);
          const j = i * 4;
          o[j] = (nx / l * 0.5 + 0.5) * 255;
          o[j + 1] = (ny / l * 0.5 + 0.5) * 255;
          o[j + 2] = (1 / l * 0.5 + 0.5) * 255;
          o[j + 3] = 255;
        }
      }
      cx.putImageData(out, 0, 0);
      t.needsUpdate = true;
    });
    this.textures[key] = t;
    return t;
  }

  // The relief map for a texture we have already loaded, found by identity: the zone branches know
  // which finish they chose but not which photo name it resolved to. A MIRRORED zone samples a
  // clone with repeat.y = -1 and has no PHOTOS entry of its own, so it is traced back to its source
  // and given a mirrored relief to match - otherwise one outer shoulder of a grooved face rendered
  // in relief and the other, same finish, stayed flat.
  reliefFor(map) {
    if (!this._relief || !map) return null;
    for (const k in this.textures) {
      if (this.textures[k] !== map || k.indexOf('nrm:') === 0) continue;
      const flip = !!map._fndFlip || /_flip$/.test(k);
      const src = PHOTOS[k] ? k : (map._fndSrc || k.replace(/_flip$/, ''));
      return PHOTOS[src] ? this.normalFrom(src, 1, flip) : null;
    }
    return null;
  }

  // ONE PLACE THAT ATTACHES A FINISH PHOTO TO A MATERIAL. RELIEF MODE. The finish photos have
  // always been used as COLOUR maps, i.e. a picture of hammering painted flat onto a smooth
  // surface: the pattern cannot catch a highlight, because as far as the renderer is concerned the
  // metal is still perfectly smooth. Here the same image also drives a NORMAL map, so the surface
  // genuinely faces different ways and the light moves across it as the ring turns.
  // BOTH MAPS, NOT ONE: dropping the photo and keeping only the relief measured worse, local
  // contrast across the ring falling from 45 to 32, because the photo carries tonal variation the
  // geometry alone does not.
  // Relief was previously wired in at each site that happened to set a finish map, and the third
  // such site (a metal line set to 'Same as the face') was missed, so the face rendered in relief
  // while the line painted against it stayed smooth, with a different base roughness too.
  finishMaps(m, name) {
    if (!this._relief) { m.map = this.tex(name); return m; }
    const nm = this.normalFrom(name, 1);
    if (!nm) { m.map = this.tex(name); return m; }
    // De-shaded colour, so the only light on the metal is ours.
    m.map = this.flatFrom(name) || this.tex(name);
    m.normalMap = nm;
    // Strength is modest BY DESIGN. A pixel-diff against the flat build rewards exaggeration, and
    // following it to normalScale 7 with a coarse tile produced bark rather than hammered metal.
    // What made the relief invisible in the first place was the roughness being LIFTED to 0.8,
    // which broadens the specular lobe and erases the per-dent highlights; the base is now left
    // exactly as the finish set it.
    m.normalScale = new THREE.Vector2(1.8, 1.8);
    m.roughnessMap = m.map;
    return m;
  }

  // THE FINISH PHOTOS ARE NOT ALBEDO, THEY ARE RENDERS. Their dark patches are shadows cast by
  // whatever light was on the metal when it was shot, which is why painting them on flat looked
  // like texture at all. Once the relief generates real shading from OUR light, those baked
  // shadows are a second, fossilised light source that cannot move: the merchant caught this
  // (21 Sep 2026). So the colour map is DE-SHADED here - the photo divided by a heavy blur of
  // itself, which removes the large-scale lighting and keeps only the fine grain of the material -
  // and centred near white so it tints rather than darkens the metal.
  // This also corrects an earlier wrong conclusion of mine: dropping the photo cost 'local
  // contrast' (sd 45 -> 32), but that contrast WAS the fake shadow. Losing it is the point.
  flatFrom(name) {
    const key = 'flat:' + name;
    if (this.textures[key]) return this.textures[key];
    const p = PHOTOS[name];
    if (!p) return null;
    const S = 256;
    const cv = document.createElement('canvas'); cv.width = cv.height = S;
    const cx = cv.getContext('2d', { willReadFrequently: true });
    cx.fillStyle = 'rgb(230,230,230)'; cx.fillRect(0, 0, S, S);
    const t = new THREE.CanvasTexture(cv);
    t.wrapS = t.wrapT = THREE.RepeatWrapping;
    t.repeat.set(p[1], p[2]);
    t.colorSpace = THREE.SRGBColorSpace;
    this.sharpen(t);
    this.photoBitmap(name).then((img) => {
      if (!img) return;
      cx.drawImage(img, 0, 0, S, S);
      const src = cx.getImageData(0, 0, S, S).data;
      const lum = new Float32Array(S * S);
      for (let i = 0; i < S * S; i++) lum[i] = (src[i * 4] * 0.299 + src[i * 4 + 1] * 0.587 + src[i * 4 + 2] * 0.114) / 255;
      // THE BLUR IS A DOWNSAMPLE. A separable R=22 blur over the full image was 13ms of blocking
      // work, and a 32px draw of the same photo is the same thing: the browser box-filters it in
      // native code, and the large-scale lighting is all that survives at that size, which is
      // exactly what we want to divide out.
      // B IS DELIBERATELY TINY. The divisor must hold ONLY the broad gradient of the shoot: at 32
      // it removed everything coarser than about eight texels, which is exactly the scale hammer
      // facets live at, so the de-shade took the subject out with the lighting and the face came
      // back a smooth grey band. At 8 the studio gradient still goes and the facets survive.
      const B = 8;
      const bc = document.createElement('canvas'); bc.width = bc.height = B;
      const bx = bc.getContext('2d', { willReadFrequently: true });
      bx.drawImage(img, 0, 0, B, B);
      const bsrc = bx.getImageData(0, 0, B, B).data;
      const blurAt = (x, y) => {
        const i = (((y * B / S) | 0) * B + ((x * B / S) | 0)) * 4;
        return (bsrc[i] * 0.299 + bsrc[i + 1] * 0.587 + bsrc[i + 2] * 0.114) / 255;
      };
      const out = cx.createImageData(S, S), o = out.data;
      // CENTRE ON THE PHOTO'S OWN MEAN, not on white. Dividing by the blur removes the large-scale
      // lighting, but normalising the result to ~1 also throws away the metal's overall tone and
      // the ring comes out pale. Keeping the mean holds the tone and drops only the shadows.
      let avg = 0;
      for (let i = 0; i < S * S; i++) avg += lum[i];
      avg /= S * S;
      for (let y = 0; y < S; y++) {
        for (let x = 0; x < S; x++) {
          const i = y * S + x;
          const ratio = lum[i] / Math.max(0.02, blurAt(x, y));
          const v = Math.max(0, Math.min(1, avg * (1 + (ratio - 1) * 0.55)));
          const j = i * 4;
          o[j] = o[j + 1] = o[j + 2] = v * 255;
          o[j + 3] = 255;
        }
      }
      cx.putImageData(out, 0, 0);
      t.needsUpdate = true;
    });
    this.textures[key] = t;
    return t;
  }

  // ONE DECODE, OFF THE MAIN THREAD, SHARED. normalFrom and flatFrom each loaded the photo
  // themselves, so choosing a finish cost two main-thread decodes of a 2000px image and froze a
  // frame for 50-100ms on the very interaction this feature exists for. createImageBitmap decodes
  // AND downsamples in the browser, off-thread; the Image path is the fallback.
  photoBitmap(name) {
    this._bmp = this._bmp || {};
    if (this._bmp[name]) return this._bmp[name];
    const p = PHOTOS[name];
    if (!p) return Promise.resolve(null);
    const url = A(p[0]);
    const pr = (typeof createImageBitmap === 'function' && typeof fetch === 'function'
      ? fetch(url, { mode: 'cors' }).then((r) => r.blob()).then((b) => createImageBitmap(b, { resizeWidth: 256, resizeHeight: 256, resizeQuality: 'high' }))
      : Promise.reject(new Error('no bitmap'))
    ).catch(() => new Promise((res) => {
      const i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = () => res(i);
      i.onerror = () => res(null);
      i.src = url;
    }));
    this._bmp[name] = pr;
    return pr;
  }

  mat(def, extra) { const m = new THREE.MeshPhysicalMaterial({ color: def.color ?? 0xffffff, metalness: def.metal ?? 0.75, roughness: def.rough ?? 0.4, envMapIntensity: 1.5, side: THREE.DoubleSide, ...extra }); if (def.tex) { m.map = this.tex(def.tex); m.metalness = def.tex === 'carbon' ? 0.5 : 0.12; } return m; }
  // COPLANAR STACK, 20 Sep 2026: rank the overlay strips so the GPU biases their depth at
  // rasterisation (polygonOffset) rather than relying on 0.003-unit radial gaps to separate them,
  // and give each a matching renderOrder so the draw sequence is identical every frame. A tie in
  // the depth buffer resolved by draw order is what flickered. Ranks follow the radial order the
  // strips are already built at: face 1, zirconium face cover 2, zone overlay 3, groove 4, inlay 5,
  // inlay rim 6, metal line 7. The line sits ABOVE the inlay deliberately - a between-the-inlays or
  // narrow-side line is drawn on the inlay's own surface (+0.035 then +0.032) and has to stay on
  // top, the same reasoning as the groove note in build(). DO NOT re-separate these by nudging the
  // radial offsets; that is what did not work. The offsets stay as they are.
  lift(m, rank) {
    m.polygonOffset = true;
    // FACTOR STAYS 0. polygonOffsetFactor scales the bias by the fragment's depth SLOPE, which on a
    // lathe goes near-infinite at the silhouette, so a non-zero factor flings the far side's back
    // faces (DoubleSide, normals pointing away, so they shade near-black) in front of the near
    // face. Symptoms: the metal line drops out of the outer face and reappears on the bore, and it
    // is view-dependent, so it comes and goes as the ring idles. Every strip here is a concentric
    // cylinder sharing one slope, so the factor term buys nothing and only breaks things.
    m.polygonOffsetFactor = 0;
    // Units are a FLAT bias in depth quanta, which is exactly what coplanar decal layers need.
    // 4 per rank clears the 3-8 quanta the 16-bit gaps get, and the bore is ~2000 quanta away, so
    // 4-32 cannot reach the ring's interior.
    m.polygonOffsetUnits = -rank * 4;
    return m;
  }
  build() {
    const g = this.group, c = this._cfg; if (!c) return;
    // Tell the loop to re-fit. Most config changes rebuild the group with the SAME mesh count, so a
    // child-count gate misses them, and anything fitToGroup assigns (the shadow casters, the floor's
    // size) would be left behind on the meshes that no longer exist.
    this._rebuilt = true;
    while (g.children.length) { const ch = g.children.pop(); ch.geometry?.dispose(); ch.material?.dispose(); }
    // THE RING IS DRAWN AT ITS OWN SIZE, 22 Sep 2026. It used to be a fixed 20mm bore (about a US
    // 10) with a 1.25mm wall for every design, so an 8mm band on a US 5 looked as slim as on a US
    // 14 and the gaps in a row of stones never matched the customer's size. The bore now comes from
    // the US size in c.size (inner diameter = 11.63 + 0.8128 x US, the standard mandrel figure), or
    // c.innerD in mm, falling back to the old 20mm when neither is given, so pages that pass no size
    // (the ad reel, the compare pages) are unchanged in proportion. The wall is 2.0mm, which is
    // what the stock rings' weights imply (1.25 read as a thin shell). The camera re-fits to the
    // ring, so size changes PROPORTION on screen, not how big the ring looks.
    const usM = /US\s*([\d.]+)/.exec(String(c.size || ''));
    const innerD = c.innerD || (usM ? 11.63 + 0.8128 * parseFloat(usM[1]) : 20);
    // Wall from the builder's wallMm() (c.wallT) so the render and the step 03 note never disagree;
    // 2.0 when a page passes none.
    const R = Math.max(7, Math.min(14, innerD / 2)), T = c.wallT ? Math.max(1, Math.min(3.5, c.wallT)) : 2.0, w = c.width || 8, hw = w / 2, mm = 1;
    this._ringR = R + T;
    const court = c.profile === 'Court';
    const bevel = c.edge === 'Bevelled' ? Math.max(0.3, Math.min(2, c.bevelW || 0.75)) : 0, step = c.edge === 'Stepped edge' ? (c.stepW ? Math.max(0.3, Math.min(2, c.stepW)) : 0.45) : 0;
    const be = Math.max(bevel, step);
    // Grooves are 0.35mm wide by default; the builder may widen them. Depth stays 0.25mm.
    const gh = Math.max(0.35, Math.min(2, c.grooveW || 0.35)) / 2;
    const grooves = []; // spans on face, {y, half}
    // The builder decides where a single centre groove ends up (it moves aside for metal lines),
    // so the quote and the render agree. Do not recompute it here.
    if (c.groove === 'Single centre groove') grooves.push({ y: c.grooveY || 0, half: gh });
    if (c.groove === 'Twin grooves') { const inset = c.grooveInset || 1.5; const gy = hw - be - inset; grooves.push({ y: -gy, half: gh }, { y: gy, half: gh }); }
    // The offset groove's y comes from the BUILDER (grooveOffY), which owns the offset maths and
    // the limits the slider is clamped to. The 20% fallback is only for links saved before that.
    if (c.groove === 'Offset groove') grooves.push({ y: typeof c.grooveOffY === 'number' ? c.grooveOffY : (c.grooveFlip ? -w * 0.2 : w * 0.2), half: gh });
    const inlays = []; // {y, half}
    // Inlay rim positions, and the spans of every metal line actually drawn. The rims are drawn
    // last so a line flush against a channel can suppress the rim on that edge.
    const rimYs = [], pinSpans = [];
    if (c.inlay) {
      const iw = c.inlayW || 2, ih = iw / 2;
      if (c.count === 'Double') { inlays.push({ y: -(ih + 0.5), half: ih, mat: c.inlay2 }, { y: ih + 0.5, half: ih }); }
      else if (c.count === 'Triple') { inlays.push({ y: 0, half: ih }, { y: -(iw + 0.5), half: ih, mat: c.inlay3 || c.inlay2 }, { y: iw + 0.5, half: ih, mat: c.inlay2 }); }
      else if (/^Offset \(/.test(c.placement || '')) { const off = parseFloat(c.placement.match(/([\d.]+)mm/)[1]); inlays.push({ y: hw - off - ih, half: ih }); }
      else inlays.push({ y: 0, half: ih });
    }
    const outerR = y => {
      // THE COURT DOME EATS INTO THE WALL, IT DOES NOT ADD TO IT (merchant, 22 Sep 2026). The wall
      // T is the thickness at the crown of the face, which is where anyone measures it, and the dome
      // falls away towards the edges. It used to be ADDED on top (a fixed 0.32mm), which put the
      // crown of a court band 0.32 above the stated wall and made a 2mm band read as round wire.
      // The dome also scales with width, so the profile keeps the same shape at every width.
      // 28 Sep 2026: 0.05 x width (0.40mm at 8mm), matched to the merchant's own made court ring:
      // 2.3mm in the middle, ~1.6mm at the edge, with the inside rounding (below) taking the rest.
      const dome = court ? (typeof c.domeK === 'number' ? Math.max(0, Math.min(0.15, c.domeK)) : 0.05) * w : 0;
      let r = R + T - dome * (1 - Math.cos((y / hw) * Math.PI / 2));
      for (const gr of grooves) { const d = Math.abs(y - gr.y); if (d < gr.half) r -= 0.25 * Math.cos((d / gr.half) * Math.PI / 2); }
      return r;
    };
    // COMFORT FIT INSIDE, 28 Sep 2026 (Tizti: "outside & inside rounded"). Every metal band, court
    // AND flat, is rounded inside: true size at the centre, where the finger is measured and the
    // ring is tightest, opening by 0.0375 x width at each edge (0.30mm at 8mm). Matched to the
    // merchant's made rings: flat 2.3 middle / ~2.0 edge, court 2.3 / ~1.6. Organic rings keep a
    // straight bore. c.innerDome (mm) overrides. Anything laid on the bore follows innerR.
    const organicBore = !!(METALS[c.metal] || {}).organic;
    const innerDome = organicBore ? 0 : typeof c.innerDome === 'number' ? Math.max(0, Math.min(0.6, c.innerDome)) : 0.0375 * w;
    const innerR = y => R + innerDome * (1 - Math.cos((Math.max(-hw, Math.min(hw, y)) / hw) * Math.PI / 2));
    const boreLathe = (off, a, b) => { const n = innerDome ? 24 : 1, out = []; for (let i = 0; i <= n; i++) { const y = a + (b - a) * i / n; out.push(new THREE.Vector2(innerR(y) + off, y)); } return out; };
    // SAMPLE LIST for any lathe that follows outerR across a span. 20 Sep 2026: a groove is only
    // 0.35-2mm wide on a face several mm across, so a uniform 40-sample polyline steps straight
    // over the cut - the strip CHORDS from one rim to the other and hoops ABOVE the groove floor,
    // burying the groove's own strip except at the rims, where the dip is shallow enough for it to
    // surface. That is why a plated groove showed only as two hairlines on a faceted or hammered
    // ring: those finishes draw a face strip, while Polished and Fine brushed matt bump-map the
    // band mesh itself (which carries the real groove geometry) and so never had the fault.
    // Grooves therefore get their own dense samples, plus a point just outside each rim so the
    // strip is at full radius before it starts to dip.
    const profileYs = (a, b, n) => {
      const ys = [];
      for (let i = 0; i <= n; i++) ys.push(a + (i / n) * (b - a));
      for (const gr of grooves) {
        const lo = gr.y - gr.half, hi = gr.y + gr.half;
        if (hi <= a || lo >= b) continue;
        const GN = 16;
        for (let i = 0; i <= GN; i++) { const y = lo + (i / GN) * (hi - lo); if (y > a && y < b) ys.push(y); }
        for (const e of [lo - 0.012, hi + 0.012]) if (e > a && e < b) ys.push(e);
      }
      ys.sort((p, q) => p - q);
      return ys.filter((y, i) => i === 0 || y - ys[i - 1] > 1e-4);
    };
    // closed cross-section loop
    const pts = [];
    if (innerDome) { for (let i = 0; i <= 24; i++) { const y = -hw + (2 * hw * i) / 24; pts.push(new THREE.Vector2(innerR(y), y)); } }
    else pts.push(new THREE.Vector2(R, -hw), new THREE.Vector2(R, hw));
    const faceLo = -hw + Math.max(bevel, step), faceHi = hw - Math.max(bevel, step);
    if (bevel) pts.push(new THREE.Vector2(outerR(faceHi) - bevel * 0.55, hw));
    else if (step) { pts.push(new THREE.Vector2(outerR(faceHi) - 0.35, hw)); pts.push(new THREE.Vector2(outerR(faceHi) - 0.35, faceHi)); }
    const N = 80;
    for (let i = 0; i <= N; i++) { const y = faceHi - (i / N) * (faceHi - faceLo); pts.push(new THREE.Vector2(outerR(y), y)); }
    if (bevel) pts.push(new THREE.Vector2(outerR(faceLo) - bevel * 0.55, -hw));
    else if (step) { pts.push(new THREE.Vector2(outerR(faceLo) - 0.35, faceLo)); pts.push(new THREE.Vector2(outerR(faceLo) - 0.35, -hw)); }
    pts.push(new THREE.Vector2(innerR(-hw), -hw));
    // FILLETED EDGES, 21 Sep 2026. A real ring has no 90 degree corners: every edge is broken, and
    // that tiny round is what catches a highlight line and reads as metal. A hard corner reads as
    // geometry. Only the genuine corners are rounded (turns sharper than ~154 degrees), so the 80
    // samples along the face and the shallow groove rims are left exactly as they were - and the
    // face's own ends are skipped outright, because the face strips are laid at outerR across
    // precisely that span and rounding there would leave a strip's edge standing proud of the band.
    const filletProfile = (src, rad) => {
      const out = [];
      for (let i = 0; i < src.length; i++) {
        const p = src[i], a = src[i - 1], b = src[i + 1];
        if (!a || !b || Math.abs(p.y - faceHi) < 1e-6 || Math.abs(p.y - faceLo) < 1e-6) { out.push(p); continue; }
        const d1 = new THREE.Vector2().subVectors(a, p), d2 = new THREE.Vector2().subVectors(b, p);
        const l1 = d1.length(), l2 = d2.length();
        if (l1 < 1e-4 || l2 < 1e-4) { out.push(p); continue; }
        d1.divideScalar(l1); d2.divideScalar(l2);
        if (d1.dot(d2) < -0.9) { out.push(p); continue; }
        const f = Math.min(rad, l1 * 0.45, l2 * 0.45);
        const s = p.clone().addScaledVector(d1, f), e = p.clone().addScaledVector(d2, f), K = 4;
        for (let k = 0; k <= K; k++) {
          const t = k / K, u = 1 - t;
          out.push(new THREE.Vector2(u * u * s.x + 2 * u * t * p.x + t * t * e.x, u * u * s.y + 2 * u * t * p.y + t * t * e.y));
        }
      }
      return out;
    };
    // HAMMERED IS A SHAPE, NOT A PICTURE. Auronia's hammered band breaks its own SILHOUETTE - the
    // outline of the ring is scalloped where the dents meet the edge - which no image map can do,
    // and which is why every texture-based attempt at this reads as a sticker. So for hammered and
    // faceted the dents are cut into the geometry: a lattice of dimples pressed into the face, each
    // one a real surface facing its own direction. The lathe doubles its segments for this and only
    // this, because a dimple needs several vertices across it to exist at all.
    // STRUCK REQUIRES A UNIFORMLY HAMMERED FACE, and deliberately falls back to the flat strips
    // when it is not. Two configurations make the face non-uniform, and both broke when the dents
    // were cut across the whole of it: the per-side rule (an offset inlay leaves two runs and the
    // builder may hammer only the wider one, with the other brushed - dimpling both makes the
    // render contradict the millimetre figures in the summary), and a groove splitting the face
    // into separately finished zones (whose overlay strips sit at outerR + 0.025 and hood every
    // dent underneath them, so the customer picks Hammered and gets a flat zone). Same lesson as
    // the buried stone and the filled groove: check what else is drawn at that radius.
    const zoneSplitFace = (c.groove === 'Twin grooves' || c.groove === 'Offset groove')
      && (c.grooveInside || c.grooveOutside)
      && (c.grooveInside !== c.grooveOutside || (c.grooveInsideHex || '') !== (c.grooveOutsideHex || ''));
    const perSideFace = c.texSide === 'Wider side only' && /Hammered|Coarse brushed hammer|Faceted hammer/.test(c.finish || '');
    const struck = this._relief && !(METALS[c.metal] || {}).organic && /hammer|faceted/i.test(c.finish || '')
      && !zoneSplitFace && !perSideFace;
    const geo = new THREE.LatheGeometry(filletProfile(pts, 0.09), struck ? 360 : 160);
    if (struck) {
      const pos = geo.attributes.position, v = new THREE.Vector3();
      const faceW = Math.max(0.6, faceHi - faceLo);
      const circ = 2 * Math.PI * (R + T);
      // Dents about 1.4mm across, the size a small hammer leaves, and laid out in offset rows so
      // they pack like peening rather than sitting in a grid.
      // FACETED IS NOT HAMMERED WITH BIGGER DENTS. The merchant's product video of the faceted
      // antler band (22 Sep 2026) shows FLAT PLANES meeting at crisp straight ridges, each plane
      // holding one even tone, and cells noticeably TALLER THAN WIDE - roughly two rows up an 8mm
      // face, not four. That is a planed surface, not a struck one, so it gets its own geometry
      // below rather than a scaled copy of the hammer dish.
      const faceted = /Faceted/.test(c.finish || '');
      const pitch = faceted ? 2.2 : 1.35;
      const nAround = Math.max(12, Math.round(circ / pitch));
      // Cells are stretched vertically for faceted, which is what makes the facets read as long
      // planes running across the band rather than as a field of lozenges.
      const rows = Math.max(1, Math.round(faceW / (pitch * (faceted ? 1.9 : 1))));
      const rowH = faceW / rows;
      const depth = faceted ? 0.1 : 0.075;
      // OVERLAPPING STRIKES, NOT A DOT LATTICE. A grid of round dimples reads as circular dents in
      // a smooth surface, which is not what hammering looks like: each blow overlaps its
      // neighbours, so the boundary between two dents is the straight ridge halfway between where
      // they landed. That makes the pattern a Voronoi field - cells of four to six sides, similar
      // in size but each one different, some squarer than others - which is the merchant's own
      // description of the real thing (21 Sep 2026).
      // Centres sit on a jittered lattice; the surface inside a cell is a dish measured by the
      // RATIO of the nearest strike's distance to the second nearest, so it is deepest where the
      // hammer landed and exactly zero along every shared edge, whatever size the cell is.
      // INTEGER MIX, NOT Math.sin. This runs nine times per face vertex, 272,916 lookups on an 8mm
      // band, and a sin-based hash cost 11.9ms of a 19ms rebuild - over a frame, on every config
      // change, including each input event while a width slider is dragged. The bit mix is the
      // same thing statistically and benchmarks at 1.3ms for the identical workload.
      const hash2 = (i, j) => {
        let h = Math.imul(i, 374761393) + Math.imul(j, 668265263) | 0;
        h = Math.imul(h ^ (h >>> 13), 1274126177);
        let g = Math.imul(i, 2246822519) + Math.imul(j, 3266489917) | 0;
        g = Math.imul(g ^ (g >>> 15), 2654435761);
        return [((h ^ (h >>> 16)) >>> 0) / 4294967296, ((g ^ (g >>> 13)) >>> 0) / 4294967296];
      };
      for (let i = 0; i < pos.count; i++) {
        v.fromBufferAttribute(pos, i);
        const rad = Math.hypot(v.x, v.z), y = v.y;
        if (rad < R + T * 0.55 || y < faceLo || y > faceHi) continue;
        const th = Math.atan2(v.z, v.x);
        const u = (th / (2 * Math.PI)) * nAround;
        const vv = (y - faceLo) / rowH;
        const ci = Math.floor(u), cj = Math.floor(vv);
        let d1 = 1e9, d2 = 1e9, jit = 1, bx = 0, by = 0, bi = 0, bj = 0;
        for (let oi = -1; oi <= 1; oi++) {
          for (let oj = -1; oj <= 1; oj++) {
            const gi = ci + oi, gj = cj + oj;
            // wrap the hash around the circumference so the seam has no visible join
            const wi = ((gi % nAround) + nAround) % nAround;
            const h = hash2(wi, gj);
            const sx = gi + 0.15 + 0.7 * h[0], sy = gj + 0.15 + 0.7 * h[1];
            const dd = Math.hypot(u - sx, vv - sy);
            if (dd < d1) { d2 = d1; d1 = dd; jit = 0.75 + 0.5 * h[1]; bx = sx; by = sy; bi = wi; bj = gj; }
            else if (dd < d2) d2 = dd;
          }
        }
        const t = d2 > 1e-6 ? Math.min(1, d1 / d2) : 1;
        // A HAMMER LEAVES A DISH, A PLANING TOOL LEAVES A PLANE. Hammered keeps the hollow that is
        // deepest where the blow landed and zero along every shared edge. Faceted instead gives
        // each cell its own flat, slightly tilted plane, so the tone is even across a facet and
        // the boundary between two facets is a hard step - which is exactly the crisp ridge the
        // product video shows, and the reason a facet reads as a cut surface rather than a dent.
        let dip;
        if (faceted) {
          const g = hash2(bi + 1013, bj - 577);
          const tu = (g[0] - 0.5) * 2.4, tv = (g[1] - 0.5) * 2.4;
          dip = depth * (0.5 + jit * 0.35 + tu * (u - bx) + tv * (vv - by));
          dip = Math.max(0, Math.min(depth * 1.3, dip));
        } else dip = depth * jit * (1 - t * t);
        // Fade out only where there is something to protect. A bevel or stepped edge is a crisp
        // machined line and a dent running into it reads as damage, so the displacement dies
        // 0.25mm short of it. On a PLAIN edge there is nothing to protect and the dents run to the
        // rim, which is what breaks the silhouette - the one signature that tells a customer this
        // is struck metal and not a photograph of it.
        const edge = be > 0 ? Math.min(1, Math.min(y - faceLo, faceHi - y) / 0.25) : 1;
        const s = (rad - dip * edge) / rad;
        pos.setX(i, v.x * s); pos.setZ(i, v.z * s);
      }
      pos.needsUpdate = true;
      geo.computeVertexNormals();
    }
    // (hammered now renders via photo relief strips; vertex displacement retired)
    if (false) {
      const pos = geo.attributes.position, v = new THREE.Vector3();
      for (let i = 0; i < pos.count; i++) {
        v.fromBufferAttribute(pos, i);
        const rad = Math.hypot(v.x, v.z), y = v.y;
        if (rad > R + T * 0.55 && y > faceLo + 0.15 && y < faceHi - 0.15) {
          let clear = true;
          for (const inl of inlays) if (Math.abs(y - inl.y) < inl.half + 2 * mm) clear = false;
          for (const gr of grooves) if (Math.abs(y - gr.y) < gr.half + 0.3) clear = false;
          if (clear) {
            const a = Math.atan2(v.z, v.x);
            const n = Math.sin(a * 9.3 + y * 2.7) + 0.6 * Math.sin(a * 17.1 + y * 6.1) + 0.35 * Math.sin(a * 31 + y * 12);
            const s = (rad + 0.05 * n) / rad;
            pos.setX(i, v.x * s); pos.setZ(i, v.z * s);
          }
        }
      }
      geo.computeVertexNormals();
    }
    const mdef = { ...(METALS[c.metal] || METALS.Tungsten) };
    if (c.colourHex && !mdef.organic) { mdef.color = new THREE.Color(c.colourHex).getHex(); delete mdef.tex; }
    const zirc = c.metal === 'Black Zirconium';
    if (zirc) { mdef.color = 0x26272a; mdef.rough = 0.45; } // heat-treated zirconium: near-black, matte even when polished
    const RAWZ = 0x9aa0a8;
    const rough = c.finish === 'Polished' ? Math.max(zirc ? 0.3 : 0.08, (mdef.rough ?? 0.4) - 0.22)
      : c.finish === 'Hammered' ? (mdef.rough ?? 0.4) + 0.05
      : /Coarse brushed hammer/.test(c.finish || '') ? (mdef.rough ?? 0.4) + 0.3
      : /Rough brushed/.test(c.finish || '') ? (mdef.rough ?? 0.4) + 0.22
      : /Sandblasted/.test(c.finish || '') ? (mdef.rough ?? 0.4) + 0.35
      : /Faceted/.test(c.finish || '') ? (mdef.rough ?? 0.4) + 0.12
      : mdef.rough;
    const bandMat = this.mat({ ...mdef, rough });
    // dark colours swallow the relief maps: lift the tint and boost reflections so texture still catches light
    const liftDark = (col) => {
      const cc = new THREE.Color(col);
      const lum = cc.r * 0.299 + cc.g * 0.587 + cc.b * 0.114;
      return lum < 0.16 ? { color: cc.lerp(new THREE.Color(0x4d5057), 0.14).getHex(), env: 2.6 } : { color: cc.getHex(), env: null };
    };
    // organic base: tungsten wrap over the antler/oak face
    if (mdef.organic && c.wrap && c.wrap !== 'None') {
      const wcol = c.colourHex ? new THREE.Color(c.colourHex).getHex() : 0x4a4e54;
      const full = c.wrap === 'Full cover';
      const flush = c.wrap === 'Flush to one edge';
      // The builder now sends the band as its two EDGES across the face (wrapLo/wrapHi, mm from the
      // low edge), which is what the two-ended slider sets and the only way an off-centre band can
      // be expressed. The preset maths below is kept for older saved links, which carry wrap+wrapW
      // and no edges.
      const band = c.wrapLo != null && c.wrapHi != null && c.wrapHi - c.wrapLo > 0.05;
      const span = faceHi - faceLo;
      const wh = band ? Math.max(0.05, Math.min((c.wrapHi - c.wrapLo) / 2, span / 2) - 0.02)
        : full ? span / 2 - 0.02 : Math.min((c.wrapW || 3) / 2, span / 2 - (flush ? 0.5 : 1));
      const wy = band ? Math.max(faceLo + wh + 0.02, Math.min(faceHi - wh - 0.02, faceLo + (c.wrapLo + c.wrapHi) / 2))
        : full ? (faceLo + faceHi) / 2 : flush ? faceHi - wh - 0.02 : (faceLo + faceHi) / 2;
      const wp = []; const WM = 30;
      for (let i = 0; i <= WM; i++) { const y = wy - wh + (i / WM) * wh * 2; wp.push(new THREE.Vector2(outerR(y) + 0.06, y)); }
      const wld = liftDark(wcol);
      const wm2 = new THREE.MeshPhysicalMaterial({ color: wld.color, metalness: 0.75, envMapIntensity: wld.env || 1.3, side: THREE.DoubleSide, roughness: 0.35 });
      if (/Rough brushed/.test(c.finish || '')) { wm2.metalness = 0.55; wm2.roughness = wld.env ? 0.5 : 0.6; this.finishMaps(wm2, 'roughrelief'); }
      else if (/Sandblasted/.test(c.finish || '')) { wm2.metalness = 0.25; wm2.roughness = wld.env ? 0.72 : 0.85; wm2.envMapIntensity = wld.env ? 1.1 : 0.6; this.finishMaps(wm2, 'sandrelief'); }
      else if (c.finish === 'Polished') { wm2.roughness = 0.1; }
      else { const bt = this.tex('brushfine'); wm2.bumpMap = bt; wm2.bumpScale = 0.008; wm2.roughnessMap = bt; wm2.roughness = 0.7; }
      const wmesh = new THREE.Mesh(new THREE.LatheGeometry(wp, 160), this.lift(wm2, 8));
      wmesh.renderOrder = 8; g.add(wmesh);
      if (!full) {
        // rim lines where metal meets organic (skip the edge-flush side)
        const rims = flush ? [wy - wh] : [wy - wh, wy + wh];
        for (const yy of rims) {
          const rp = [new THREE.Vector2(outerR(yy) + 0.065, yy - 0.02), new THREE.Vector2(outerR(yy) + 0.065, yy + 0.02)];
          g.add(new THREE.Mesh(new THREE.LatheGeometry(rp, 160), new THREE.MeshPhysicalMaterial({ color: 0x111111, metalness: 0.8, roughness: 0.4, side: THREE.DoubleSide })));
        }
      }
    }
    // face strips: photo-mapped finish over the face, running to the inlay edges
    const faceBase = c.zircFace ? RAWZ : mdef.color;
    const faceSegs = () => {
      let segs = [[faceLo + 0.03, faceHi - 0.03]];
      for (const inl of inlays) {
        const next = [];
        for (const [a, b] of segs) {
          const ca = inl.y - inl.half - 0.05, cb = inl.y + inl.half + 0.05;
          if (cb <= a || ca >= b) { next.push([a, b]); continue; }
          if (ca - a >= 0.3) next.push([a, ca]);
          if (b - cb >= 0.3) next.push([cb, b]);
        }
        segs = next;
      }
      return segs;
    };
    const stripAt = (a, b, mapName, mopts) => {
      const { bump, ...rest } = (mopts || {});
      const fp = []; const FM = 40;
      for (const y of profileYs(a, b, FM)) fp.push(new THREE.Vector2(outerR(y) + 0.02, y));
      const ld = liftDark(faceBase);
      const fmat = new THREE.MeshPhysicalMaterial({ color: ld.color, envMapIntensity: ld.env || 1.2, side: THREE.DoubleSide, ...rest, ...(ld.env ? { roughness: Math.max(0.3, (rest.roughness ?? 0.5) - 0.12) } : {}) });
      if (mapName) this.finishMaps(fmat, mapName);
      if (bump) { const bt = this.tex(bump); fmat.bumpMap = bt; fmat.bumpScale = 0.008; fmat.roughnessMap = bt; }
      const fmesh = new THREE.Mesh(new THREE.LatheGeometry(fp, 160), this.lift(fmat, 1));
      fmesh.renderOrder = 1; g.add(fmesh);
    };
    // ONE PASS, 17 Sep 2026: a texture is worked across the full blank BEFORE the channel is milled,
    // so where the builder says so (c.texOnePass - matching finish both sides, one run under the
    // separately-workable 2mm) the face takes a SINGLE strip spanning the whole face rather than one
    // per segment. Two strips imply two independently hammered runs, which is not what happens, and
    // on a 1mm strip it read as a second, unrelated patch of pattern. The strip sits at
    // outerR + 0.02 and the inlay at + 0.035, so the span passing under the channel is covered by
    // it rather than fighting it. Only textured finishes ever set the flag.
    const faceSpans = () => (c.texOnePass ? [[faceLo + 0.03, faceHi - 0.03]] : faceSegs());    const addFaceStrips = (mapName, mopts) => { for (const [a, b] of faceSpans()) stripAt(a, b, mapName, mopts); };
    // One strip, finished by NAME - so a face can carry two different finishes at once (see the
    // per-side texture below). Same maps and material figures as the whole-face branches.
    const stripFinish = (a, b, f) => {
      f = f || 'Brushed';
      if (/Coarse brushed hammer/.test(f)) return stripAt(a, b, 'coarsehammer', { metalness: 0.5, roughness: 0.66 });
      if (/Faceted/.test(f)) return stripAt(a, b, 'facetrelief2', { metalness: 0.5, roughness: 0.48 });
      if (/Hammered/.test(f)) return stripAt(a, b, 'hammerrelief', { metalness: 0.5, roughness: 0.5 });
      if (/Rough brushed/.test(f)) return stripAt(a, b, 'roughrelief', { metalness: 0.55, roughness: 0.6 });
      if (/Sandblasted/.test(f)) return stripAt(a, b, 'sandrelief', { metalness: 0.25, roughness: 0.85, envMapIntensity: 0.6 });
      if (/Polished/.test(f)) return stripAt(a, b, null, { metalness: 0.78, roughness: Math.max(0.06, (mdef.rough ?? 0.4) - 0.28) });
      return stripAt(a, b, null, { metalness: 0.62, roughness: Math.min(1, (mdef.rough ?? 0.4) + 0.3), bump: 'brushfine' });
    };
    // MATCHED LINE FINISH: the standing face a line is masked onto was worked in the same pass as
    // the rest of the blank, so the line can carry the ring's own finish instead of a polish. Same
    // maps and material figures as the face branches above, with the SHARED map (no clone) and the
    // pattern brought to the face's physical size by scaling the line geometry's UVs instead -
    // see scaleUV. liftDark is applied as the face strips do, or a matched line on a dark ring
    // sits a shade darker than the face beside it.
    // Returns the V scale the caller must apply to the line's lathe, or 0 when the finish carries
    // no map (polished, or bump-only brushed) and the UVs should be left alone.
    const matchFace = (m, span) => {
      const f = c.finish || '';
      const ref = Math.max(0.01, faceHi - faceLo);
      const k = Math.max(0.02, Math.min(1, span / ref));
      const ld = liftDark(m.color.getHex());
      m.color = new THREE.Color(ld.color);
      if (ld.env) m.envMapIntensity = ld.env;
      const put = (name, metal, rough, env) => {
        m.metalness = metal; m.roughness = rough;
        // Relief included, so a matched line reads as one surface with the face in every respect,
        // not just at the tile size the 20 Sep work tuned.
        this.finishMaps(m, name);
        if (env != null && !ld.env) m.envMapIntensity = env;
        return k;
      };
      if (/Coarse brushed hammer/.test(f)) return put('coarsehammer', 0.5, 0.66);
      if (/Faceted/.test(f)) return put('facetrelief2', 0.5, 0.48);
      if (/Hammered/.test(f)) return put('hammerrelief', 0.5, 0.5);
      if (/Rough brushed/.test(f)) return put('roughrelief', 0.55, 0.6);
      if (/Sandblasted/.test(f)) return put('sandrelief', 0.25, 0.85, 0.6);
      if (/Polished/.test(f)) { m.metalness = 0.78; m.roughness = Math.max(0.06, (mdef.rough ?? 0.4) - 0.28); return 0; }
      const bt = this.tex('brushfine'); m.bumpMap = bt; m.bumpScale = 0.008; m.metalness = 0.62; m.roughness = Math.min(1, (mdef.rough ?? 0.4) + 0.3); return 0;
    };
    const matchedLine = /^(Same|Match)/i.test(c.pinFinish || '');
    if (!mdef.organic) {
    // PER-SIDE TEXTURE: an offset inlay leaves two different runs of metal, and the builder may
    // confine the hammer to the wider one (c.texSide), the other taking c.texAlt. The widest
    // segment is picked off the SAME segment list the strips are built from, so the render cannot
    // disagree with the millimetre figures the summary quotes.
    // Coarse brushed hammer is tested BEFORE the plain /brushed/i branch below, because its name
    // contains "brushed": it is hammered relief with a coarse brush worked over it, so the facets
    // must read as texture rather than shine.
    const texSegs = faceSegs();
    // The dents are IN the band now, so nothing may be laid over them: a face strip at outerR+0.02
    // would hood the whole lattice and we would be back to a picture of hammering. The band's own
    // material carries the de-shaded grain instead, and the geometry does the rest.
    if (struck) {
      this.finishMaps(bandMat, /Coarse brushed hammer/.test(c.finish || '') ? 'coarsehammer'
        : /Faceted/.test(c.finish || '') ? 'facetrelief2' : 'hammerrelief');
      bandMat.normalMap = null;
      bandMat.normalScale = new THREE.Vector2(1, 1);
    } else {
    const splitTex = c.texSide === 'Wider side only' && /Hammered|Coarse brushed hammer|Faceted hammer/.test(c.finish || '') && texSegs.length > 1;
    if (splitTex) {
      let wi = 0;
      texSegs.forEach((sg, i) => { if (sg[1] - sg[0] > texSegs[wi][1] - texSegs[wi][0]) wi = i; });
      texSegs.forEach((sg, i) => stripFinish(sg[0], sg[1], i === wi ? c.finish : (c.texAlt || 'Brushed')));
    } else if (/Coarse brushed hammer/.test(c.finish || '')) {
      addFaceStrips('coarsehammer', { metalness: 0.5, roughness: 0.66 });
    } else if (/Rough brushed/.test(c.finish || '')) {
      addFaceStrips('roughrelief', { metalness: 0.55, roughness: 0.6 });
    } else if (c.finish === 'Hammered') {
      addFaceStrips('hammerrelief', { metalness: 0.5, roughness: 0.5 });
    } else if (/brushed/i.test(c.finish || '')) {
      const bt = this.tex('brushfine');
      bandMat.bumpMap = bt; bandMat.bumpScale = 0.008; bandMat.roughnessMap = bt;
      bandMat.roughness = Math.min(1, rough + 0.35); // map multiplies, so lift the base
    } else if (/Sandblasted/.test(c.finish || '')) {
      addFaceStrips('sandrelief', { metalness: 0.25, roughness: 0.85, envMapIntensity: 0.6 });
    } else if (/Faceted/.test(c.finish || '')) {
      addFaceStrips('facetrelief2', { metalness: 0.5, roughness: 0.48 });
    }
    }
    } else if (c.finish === 'Polished') { bandMat.roughness = Math.min(bandMat.roughness, 0.35); } // organic: gentle sheen only
    // raw zirconium face over a black band (plain finishes; photo finishes pick up faceBase in addFaceStrips)
    if (c.zircFace && !mdef.organic && !/Rough brushed|Hammered|Sandblasted|Faceted|Coarse brushed hammer/.test(c.finish || '')) {
      let za = faceLo + 0.03, zb = faceHi - 0.03;
      if (c.zircFaceCover === 'Centre band') { const zh = Math.min((c.zircFaceW || 2) / 2, (faceHi - faceLo) / 2 - 0.05); const zc = (faceLo + faceHi) / 2; za = zc - zh; zb = zc + zh; }
      else if (c.zircFaceCover === 'From top edge') { za = Math.max(faceLo + 0.05, faceHi - (c.zircFaceW || 2)); }
      else if (c.zircFaceCover === 'From bottom edge') { zb = Math.min(faceHi - 0.05, faceLo + (c.zircFaceW || 2)); }
      else if (c.zircFaceCover === 'Offset (1mm from edge)') { zb = faceHi - 1; za = Math.max(faceLo + 0.05, zb - (c.zircFaceW || 2)); }
      const zp = []; const ZM = 40;
      for (const y of profileYs(za, zb, ZM)) zp.push(new THREE.Vector2(outerR(y) + 0.02, y));
      const zfm = this.mat({ color: RAWZ, rough: c.finish === 'Polished' ? 0.12 : 0.45 });
      zfm.side = THREE.DoubleSide;
      if (c.finish !== 'Polished') { const bt = this.tex('brushfine'); zfm.bumpMap = bt; zfm.bumpScale = 0.008; zfm.roughnessMap = bt; }
      const zfmesh = new THREE.Mesh(new THREE.LatheGeometry(zp, 160), this.lift(zfm, 2));
      zfmesh.renderOrder = 2; g.add(zfmesh);
    }
    g.add(new THREE.Mesh(geo, bandMat));
    // inlay strips
    for (const inl of inlays) {
      const ip = []; const M = 24;
      for (let i = 0; i <= M; i++) { const y = inl.y - inl.half + (i / M) * inl.half * 2; ip.push(new THREE.Vector2(outerR(y) + 0.035, y)); }
      const matName = inl.mat || c.inlay;
      let im;
      if (METAL_INLAYS[matName]) { im = this.mat({ ...METAL_INLAYS[matName] }); const bt = this.tex('brushfine'); im.bumpMap = bt; im.bumpScale = 0.008; im.roughnessMap = bt; }
      else im = this.mat({ tex: INLAY_TEX[matName], rough: matName === 'Muonionalusta Meteorite' ? 0.3 : /Carbon/.test(matName) ? 0.42 : /Opal|Cosmos|Resin|Abalone|Agate/.test(matName) ? 0.22 : 0.55 });
      const imesh = new THREE.Mesh(new THREE.LatheGeometry(ip, 160), this.lift(im, 5));
      imesh.renderOrder = 5; g.add(imesh);
      // RIM LINES ARE DEFERRED (20 Sep 2026). The rim is a 0.06mm near-black strip marking where the
      // inlay meets metal, drawn at outerR + 0.04 - ABOVE the metal line at + 0.032. A line set
      // flush against the inlay is therefore separated from it by that dark strip, which is exactly
      // the gap the merchant reported: the geometry was already flush (line [1,2] against an inlay
      // [-1,1], measured), but the rim was painted over the seam. Where a line abuts the channel
      // there is no metal-to-inlay transition left to mark, so the rim is skipped. Collected here
      // and drawn after the pinstripe block, which is where the line spans become known.
      for (const yy of [inl.y - inl.half, inl.y + inl.half]) rimYs.push(yy);
    }
    // groove zone finishes: overlay strips around the groove(s)
    // 18 Sep 2026: the zone overlay is only for zones that genuinely DIFFER. Where both carry the
    // same finish and colour the face strips above already render the finish as one continuous pass
    // (the groove is cut afterwards, so it does not divide the work), and overlaying zone strips on
    // top of that is what made a faceted face read as separate panels.
    const zonesDiffer = c.grooveInside !== c.grooveOutside || (c.grooveInsideHex || '') !== (c.grooveOutsideHex || '');
    if (!mdef.organic && (c.groove === 'Twin grooves' || c.groove === 'Offset groove') && (c.grooveInside || c.grooveOutside) && zonesDiffer) {
      const ZR = { 'Fine brushed matt': 0.5, 'Polished': 0.1, 'Coarse brushed': 0.68, 'Faceted': 0.48, 'Sandblasted matte': 0.85, 'Hammered': 0.5, 'Coarse brushed hammer': 0.74 };
      const zgh = gh + 0.06;
      let zones;
      if (c.groove === 'Twin grooves') {
        const g1 = grooves[0].y, g2 = grooves[1].y;
        zones = [
          { a: g1 + zgh, b: g2 - zgh, f: c.grooveInside, col: c.grooveInsideHex },
          { a: faceLo + 0.05, b: g1 - zgh, f: c.grooveOutside, col: c.grooveOutsideHex },
          { a: g2 + zgh, b: faceHi - 0.05, f: c.grooveOutside, col: c.grooveOutsideHex, flip: true },
        ];
      } else {
        const gy = grooves[0].y; // narrow side is the edge nearer the groove
        zones = gy >= 0 ? [
          { a: gy + zgh, b: faceHi - 0.05, f: c.grooveInside, col: c.grooveInsideHex },
          { a: faceLo + 0.05, b: gy - zgh, f: c.grooveOutside, col: c.grooveOutsideHex },
        ] : [
          { a: faceLo + 0.05, b: gy - zgh, f: c.grooveInside, col: c.grooveInsideHex },
          { a: gy + zgh, b: faceHi - 0.05, f: c.grooveOutside, col: c.grooveOutsideHex },
        ];
      }
      for (const z of zones) {
        const r = ZR[z.f];
        if (r == null || z.b - z.a < 0.2) continue;
        // zone strips skip the inlay spans
        let zsegs = [[z.a, z.b]];
        for (const inl of inlays) {
          const nxt = [];
          for (const [sa, sb] of zsegs) {
            const ca = inl.y - inl.half - 0.05, cb = inl.y + inl.half + 0.05;
            if (cb <= sa || ca >= sb) { nxt.push([sa, sb]); continue; }
            if (ca - sa >= 0.2) nxt.push([sa, ca]);
            if (sb - cb >= 0.2) nxt.push([cb, sb]);
          }
          zsegs = nxt;
        }
        if (!zsegs.length) continue;
        const zcol = z.col ? new THREE.Color(z.col).getHex() : mdef.color;
        const zld = liftDark(zcol);
        const zc2 = zld.color, zenv = zld.env || 1.2;
        let zm;
        if (z.f === 'Faceted') {
          const inside = !z.flip && zones.indexOf(z) === 0; // central zone (between grooves) uses the new reference
          let ft = inside ? this.tex('facetrelief2') : this.tex('facetrelief');
          if (z.flip) {
            if (!this.textures.facetrelief_flip) { const f2 = ft.clone(); f2.repeat.set(ft._rx0 != null ? ft._rx0 : ft.repeat.x, -1); f2._fndSrc = 'facetrelief'; f2._fndFlip = true; f2.needsUpdate = true; this.textures.facetrelief_flip = f2; }
            ft = this.textures.facetrelief_flip;
          }
          zm = new THREE.MeshPhysicalMaterial({ map: ft, color: zc2, metalness: 0.5, roughness: zld.env ? 0.38 : 0.48, envMapIntensity: zenv, side: THREE.DoubleSide });
        } else if (z.f === 'Coarse brushed') {
          zm = new THREE.MeshPhysicalMaterial({ map: this.tex('roughrelief'), color: zc2, metalness: 0.55, roughness: zld.env ? 0.5 : 0.6, envMapIntensity: zenv, side: THREE.DoubleSide });
        } else if (z.f === 'Sandblasted matte') {
          zm = new THREE.MeshPhysicalMaterial({ map: this.tex('sandrelief'), color: zc2, metalness: 0.25, roughness: zld.env ? 0.72 : 0.85, envMapIntensity: zld.env ? 1.1 : 0.6, side: THREE.DoubleSide });
        } else if (z.f === 'Coarse brushed hammer') {
          zm = new THREE.MeshPhysicalMaterial({ map: this.tex('coarsehammer'), color: zc2, metalness: 0.5, roughness: zld.env ? 0.56 : 0.66, envMapIntensity: zenv, side: THREE.DoubleSide });
        } else if (z.f === 'Hammered') {
          zm = new THREE.MeshPhysicalMaterial({ map: this.tex('hammerrelief'), color: zc2, metalness: 0.5, roughness: zld.env ? 0.4 : 0.5, envMapIntensity: zenv, side: THREE.DoubleSide });
        } else {
          zm = this.mat({ ...mdef, color: zcol, rough: r });
          if (r > 0.45) { const bt = this.tex('brushfine'); zm.bumpMap = bt; zm.bumpScale = 0.008; zm.roughnessMap = bt; zm.roughness = Math.min(1, r + 0.3); }
        }
        // A GROOVED RING SPLITS THE FACE INTO SEPARATELY WORKABLE ZONES, and those build their own
        // materials rather than going through stripAt - so without this a two-finish band rendered
        // half in relief and half flat. Same treatment, found by matching the texture object back
        // to its name, since the branch above knows the finish but not which photo it picked.
        const znm = this.reliefFor(zm.map);
        if (znm) {
          zm.normalMap = znm; zm.normalScale = new THREE.Vector2(1.4, 1.4);
          zm.roughnessMap = zm.map; zm.roughness = Math.min(1, (zm.roughness || 0.5) * 1.6);
        }
        for (const [sa, sb] of zsegs) {
          const zp = []; const M = 16;
          for (let i = 0; i <= M; i++) { const y = sa + (i / M) * (sb - sa); zp.push(new THREE.Vector2(outerR(y) + 0.025, y)); }
          const zmesh = new THREE.Mesh(new THREE.LatheGeometry(zp, 160), this.lift(zm, 3));
          zmesh.renderOrder = 3; g.add(zmesh);
        }
      }
    }
    // GROOVE COLOUR, 18 Sep 2026: the cut itself may be plated a contrasting colour. The strip
    // follows outerR through the dip, so it LINES the groove rather than hooping over it, and sits
    // at +0.027 - clear of the face strips (+0.02) and the zone overlay (+0.025, which stops at the
    // groove rim anyway), but UNDER the metal line (+0.032). A line set into the groove shares its
    // y span exactly, and the line has to stay on top.
    // ALWAYS drawn where there is a groove, not only for a contrasting colour: the groove is CUT
    // AFTER the face is finished, by a wheel, so the inside of it is polished whatever the face
    // carries. Without this strip the face texture (which spans the whole face, the groove
    // included) ran down into the cut and a faceted or hammered ring read as a textured groove.
    if (!mdef.organic && grooves.length) {
      const gld = liftDark(c.grooveHex ? new THREE.Color(c.grooveHex).getHex() : mdef.color);
      const gmat = new THREE.MeshPhysicalMaterial({ color: gld.color, metalness: 0.8, roughness: Math.max(c.metal === 'Black Zirconium' ? 0.28 : 0.1, (mdef.rough ?? 0.4) - 0.3), envMapIntensity: gld.env || 1.4, side: THREE.DoubleSide });
      // Brushed groove (22 Oct 2026): same treatment as a brushed bevel. Only a coloured groove can be brushed.
      if (c.grooveHex && c.grooveFinish === 'Brushed') { const bt = this.tex('brushfine'); gmat.bumpMap = bt; gmat.bumpScale = 0.008; gmat.roughnessMap = bt; gmat.roughness = 0.72; }
      for (const gr of grooves) {
        const gp = []; const GM = 20;
        for (let i = 0; i <= GM; i++) { const y = gr.y - gr.half + (i / GM) * gr.half * 2; gp.push(new THREE.Vector2(outerR(y) + 0.027, y)); }
        const gmesh = new THREE.Mesh(new THREE.LatheGeometry(gp, 160), this.lift(gmat, 4));
        gmesh.renderOrder = 4; g.add(gmesh);
      }
    }
    // pinstripe: 0.5mm contrasting metal line — through the inlay centre, beside it, or set into a plain face
    // THE LINE SITS AT surfaceR + 0.052, NOT + 0.032 (20 Sep 2026). A textured finish lays a face
    // strip at outerR + 0.02, and faceSegs cuts that strip 0.05 clear of the inlay - so the strip's
    // open edge falls INSIDE a line that is flush against the channel, with only 0.012 of radial
    // clearance to lose. It leaked over the line's inner 0.3mm and read as a grey gap between the
    // line and the inlay, which is why this only ever showed on hammered, faceted, sandblasted and
    // the two brushed-hammer finishes and never on Polished or Fine brushed matt (those bump-map
    // the band itself and draw no strip at all). MEASURED by reading the canvas back: gold ran 8px
    // with a 3px dark band beside it, and 11-12px with none once the clearance went to 0.032.
    // Every other relationship is preserved: still above the groove strip (+0.027) and the inlay
    // (+0.035) so a line in a groove or on an inlay stays on top, still below the organic wrap.
    if (c.pinstripe) {
      const ph = (c.pinW || 0.5) / 2;
      let py = 0, pa = null, pb = null;
      // FLUSH TO THE BAND EDGE takes precedence over the inlay branch (20 Sep 2026). An edge line
      // and an inlay can share a face: the line sits on the shoulder, the inlay in its channel
      // further in, and the builder has already checked the run between them clears. Previously
      // this was only the else of `if (inlays.length)`, so adding an inlay silently dropped the
      // placement and forced the line beside the channel.
      if (c.pinEdge) {
        const sgn = (c.pinOffset || 0) < 0 ? -1 : 1;
        pa = sgn > 0 ? hw - (c.pinW || 0.5) : -hw;
        pb = sgn > 0 ? hw : -hw + (c.pinW || 0.5);
        py = (pa + pb) / 2;
      } else if (inlays.length) {
        const inl = inlays[0];
        if (c.pinBetween) { py = 0; }
        else if (c.pinBeside) {
          const towardEdge = inl.y >= 0 ? 1 : -1; // the nearer edge
          if (c.pinSide === 'Narrow side') {
            // fill the whole narrow strip between the inlay and the edge
            pa = towardEdge > 0 ? inl.y + inl.half : faceLo;
            pb = towardEdge > 0 ? faceHi : inl.y - inl.half;
          } else if (c.pinSide === 'Either side') {
            for (const sd of [-1, 1]) {
              // FLUSH to the channel: no clearance term. A nudge here leaves a hairline of metal
              // between the inlay and the line that the summary does not account for and no
              // workshop could cut - the strip already sits proud of the band, so nothing needs
              // separating. The clamp still keeps the line inside the flat face.
              const yy = Math.max(faceLo + ph + 0.15, Math.min(faceHi - ph - 0.15, inl.y + sd * (inl.half + ph)));
              const p2 = this.mat({ color: c.pinColourHex ? new THREE.Color(c.pinColourHex).getHex() : mdef.color, rough: c.pinFinish === 'Polished' ? 0.1 : 0.45 });
              let p2uv = 0;
              if (matchedLine) p2uv = matchFace(p2, ph * 2);
              else if (c.pinFinish === 'Rough brushed') { const rt = this.tex('roughrelief'); p2.map = rt; p2.metalness = 0.55; p2.roughness = 0.6; }
              else if (c.pinFinish === 'Brushed') { const bt = this.tex('brushfine'); p2.bumpMap = bt; p2.bumpScale = 0.008; }
              const sp2 = [new THREE.Vector2(outerR(yy) + 0.052, yy - ph), new THREE.Vector2(outerR(yy) + 0.052, yy + ph)];
              const g2 = new THREE.LatheGeometry(sp2, 160);
              pinSpans.push([yy - ph, yy + ph]);
              if (p2uv) this.scaleUV(g2, p2uv);
              const p2mesh = new THREE.Mesh(g2, this.lift(p2, 7));
              p2mesh.renderOrder = 7; g.add(p2mesh);
            }
            pa = pb = undefined; py = null;
          } else {
            let side;
            if (c.pinSide === 'Above the inlay') side = 1;
            else if (c.pinSide === 'Below the inlay') side = -1;
            else side = -towardEdge; // wide side
            py = Math.max(faceLo + ph + 0.15, Math.min(faceHi - ph - 0.15, inl.y + side * (inl.half + ph))); // flush, as above
          }
        } else py = inl.y;
      } else {
        // plain face, inset: the line sits where the customer put it, clamped so it never runs off
        // the face. The flush-to-edge case is handled above, for both plain and inlaid faces.
        py = Math.max(faceLo + ph, Math.min(faceHi - ph, c.pinOffset || 0));
      }
      if (py !== null) {
        const [ya, yb] = pa != null ? [pa, pb] : [py - ph, py + ph];
        const pmat = this.mat({ color: c.pinColourHex ? new THREE.Color(c.pinColourHex).getHex() : mdef.color, rough: c.pinFinish === 'Polished' ? 0.1 : 0.45 });
        let pinUV = 0;
        if (matchedLine) pinUV = matchFace(pmat, Math.abs(yb - ya));
        else if (c.pinFinish === 'Rough brushed') { const rt = this.tex('roughrelief'); pmat.map = rt; pmat.metalness = 0.55; pmat.roughness = 0.6; }
        else if (c.pinFinish === 'Brushed') { const bt = this.tex('brushfine'); pmat.bumpMap = bt; pmat.bumpScale = 0.008; }
        // Two lines are the same line mirrored about the centre, so they stay symmetrical however
        // the customer moves them. Only offered on a plain face.
        const spans = (c.pinLines === 2 && (c.pinEdge || !inlays.length)) ? [[ya, yb], [-yb, -ya]] : [[ya, yb]];
        // A line crossing a groove follows the groove: it is set into the surface wherever that
        // surface happens to be, so it stays flush instead of hooping over the top.
        // "Whatever surface it lies on" includes an INLAY, which is drawn 0.035 proud of the band:
        // measuring from the bare band alone left the line buried under the inlay.
        const surfaceR = (y) => {
          for (const inl of inlays) { if (y >= inl.y - inl.half && y <= inl.y + inl.half) return outerR(y) + 0.035; }
          return outerR(y);
        };
        for (const [sa, sb] of spans) {
          const pp = []; const PM = 24;
          for (let i = 0; i <= PM; i++) { const y = sa + (i / PM) * (sb - sa); pp.push(new THREE.Vector2(surfaceR(y) + 0.052, y)); }
          const pgeo = new THREE.LatheGeometry(pp, 160);
          pinSpans.push([Math.min(sa, sb), Math.max(sa, sb)]);
          if (pinUV) this.scaleUV(pgeo, pinUV);
          const pmesh = new THREE.Mesh(pgeo, this.lift(pmat, 7));
          pmesh.renderOrder = 7; g.add(pmesh);
        }
      }
    }
    // INLAY RIMS, drawn after the lines so an abutting line can suppress one. A rim whose y sits
    // at or inside a drawn line span has no metal-to-inlay edge left to mark: the line IS the
    // boundary there, and painting a near-black strip over it is what made a flush line look like
    // it had a gap. 0.02 of tolerance because a flush line's endpoint lands exactly on the rim.
    for (const yy of rimYs) {
      let covered = false;
      for (const [sa, sb] of pinSpans) if (yy >= sa - 0.02 && yy <= sb + 0.02) { covered = true; break; }
      if (covered) continue;
      const rp = [new THREE.Vector2(outerR(yy) + 0.04, yy - 0.03), new THREE.Vector2(outerR(yy) + 0.04, yy + 0.03)];
      const rmesh = new THREE.Mesh(new THREE.LatheGeometry(rp, 160), this.lift(new THREE.MeshPhysicalMaterial({ color: 0x111111, metalness: 0.8, roughness: 0.4, side: THREE.DoubleSide }), 6));
      rmesh.renderOrder = 6; g.add(rmesh);
    }
    // flush-set stones (tantalum): a brilliant sunk into a fine bezel of the base metal.
    // The stone geometry is pre-rotated so its pavilion points +Z, then lookAt(pos - dir) drops the
    // point INTO the band and leaves the table facing out, which is what a flush setting looks like.
    if (c.stone && c.stone !== 'None') {
      // EXPOSURE IS PART OF THE CUT. At envMapIntensity 4.2 with a clearcoat every crown facet ran
      // past the ACES knee and resolved to the same near-white, so the facet work was invisible and
      // the stone was still a flat disc. A brilliant reads as a light/dark MOSAIC; that needs the
      // facets to land in different unclipped bands, so the reflection is brought back to a level
      // where they separate and the second specular layer is dropped.
      // TRANSMISSION WAS TRIED HERE AND REVERTED, 21 Sep 2026. r161 supports it, and refraction is
      // genuinely what makes a real stone flash - but it refracts whatever is BEHIND the stone, and
      // on this near-black stage that is nothing. Measured on a 2.5mm stone: peak brightness fell
      // from 241 to 167 and the count of bright pixels went to zero, i.e. the stone went from a
      // white speck to a grey lump. A private high-contrast envMap on the stone alone was also
      // tried and measured no different. The lever for gem sparkle is the STAGE being bright
      // (which is what Auronia's white set buys them), not the stone's material. Do not re-add
      // transmission while the stage is dark.
      const sMat = new THREE.MeshPhysicalMaterial({ color: 0xffffff, metalness: 0, roughness: 0.055, ior: 2.42, reflectivity: 1, envMapIntensity: 1.8, side: THREE.FrontSide });
      // ON A WHITE SET the objection above does not hold: there IS something behind the stone to
      // refract, so the transmission that made it a grey lump on black is what gives it depth
      // here. Gated on the stage for that reason, not as a performance tier.
      if (this._litStage) { sMat.transmission = 1; sMat.ior = 2.15; sMat.specularIntensity = 1; }
      const bezMat = this.mat({ ...mdef, rough: 0.14 });
      const faceMid = (faceLo + faceHi) / 2, usable = Math.max(0.6, faceHi - faceLo);
      // Place the feature at whatever angle is facing the camera RIGHT NOW, or the customer picks a
      // stone and sees nothing change: the viewer idles in autorotate, so a hardcoded angle lands
      // on the far side of the band as often as not. Taken from the camera direction in the ring's
      // own space, which stays correct now that the ring can be turned over (a rotation.y reading
      // is a Euler decomposition and means nothing once the drag is a free quaternion).
      const camLocal = new THREE.Vector3(0, 0, 1).applyQuaternion(this.cam.quaternion)
        .applyQuaternion(g.getWorldQuaternion(new THREE.Quaternion()).invert());
      const camTh = Math.atan2(camLocal.z, camLocal.x);
      // A BRILLIANT, NOT A CONE. The old stone was an 8-sided cone: no table, no crown, so it took
      // one highlight across the whole face and read as a white blob. This is the real arrangement,
      // table / star facets / kite facets / girdle / pavilion, built non-indexed so the normals come
      // out FLAT and every facet takes its own reflection off the studio environment. That
      // facet-to-facet variation is the sparkle; no amount of lighting gets it out of a cone.
      const brilliant = (N) => {
        const ring = (r, y, off) => { const a = []; for (let i = 0; i < N; i++) { const th = ((i + off) / N) * Math.PI * 2; a.push(new THREE.Vector3(Math.cos(th) * r, y, Math.sin(th) * r)); } return a; };
        const girdle = ring(1, 0, 0), crown = ring(0.93, 0.13, 0.5), table = ring(0.53, 0.3, 0);
        const apex = new THREE.Vector3(0, -0.9, 0), tc = new THREE.Vector3(0, 0.3, 0);
        const pos = [];
        const ctr = new THREE.Vector3(0, -0.1, 0);
        const tri = (a, b, c2) => {
          // Wind every facet OUTWARD. computeVertexNormals follows the winding, and a facet wound
          // the wrong way is lit from inside the stone, which is what turns a brilliant back into a
          // flat white disc. Cheaper to fix by construction than to reason about each ring's order.
          const n = new THREE.Vector3().subVectors(b, a).cross(new THREE.Vector3().subVectors(c2, a));
          const out = new THREE.Vector3().addVectors(a, b).add(c2).multiplyScalar(1 / 3).sub(ctr);
          if (n.dot(out) < 0) { const t = b; b = c2; c2 = t; }
          pos.push(a.x, a.y, a.z, b.x, b.y, b.z, c2.x, c2.y, c2.z);
        };
        for (let i = 0; i < N; i++) {
          const j = (i + 1) % N;
          tri(table[i], tc, table[j]);
          tri(table[i], table[j], crown[i]);
          tri(crown[i], table[j], girdle[j]);
          tri(crown[i], girdle[j], girdle[i]);
          tri(girdle[i], girdle[j], apex);
        }
        const bg = new THREE.BufferGeometry();
        bg.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
        bg.computeVertexNormals();
        bg.rotateX(-Math.PI / 2);
        return bg;
      };
      const cone = brilliant(24);
      // The bezel hugs the crown's outer edge (0.93r) rather than standing clear of the girdle: at
      // 1.07r, with the girdle buried, a band of face or line showed between stone and rim and the
      // setting read as an oversized collar (merchant, 22 Sep 2026, against the competitor's).
      const bezG = new THREE.TorusGeometry(0.97, 0.06, 8, 28);
      // Stones sit at sy across the band (offset from centre), and are laid out either across the
      // band (varying y), along the circumference (varying th), or both for a diagonal.
      const sy0 = Math.max(faceLo + 0.4, Math.min(faceHi - 0.4, faceMid + (c.stoneOffset || 0)));
      // A stone cannot be set into an INLAY, so the free runs of metal are worked out around the
      // inlays only. Grooves are deliberately NOT treated as blockers (10 Sep 2026): a groove
      // added after the stones was shunting them off their chosen position, and a stone crossing
      // a groove is a real, and rather good, tantalum detail.
      let segs = [[faceLo + 0.03, faceHi - 0.03]];
      for (const b of inlays) {
        const lo = b.y - b.half - 0.12, hi = b.y + b.half + 0.12, next = [];
        for (const [a, z] of segs) {
          if (hi <= a || lo >= z) { next.push([a, z]); continue; }
          if (lo - a > 0.25) next.push([a, lo]);
          if (z - hi > 0.25) next.push([hi, z]);
        }
        segs = next;
      }
      if (!segs.length) segs = [[faceLo + 0.03, faceHi - 0.03]];
      const widest = segs.reduce((m, x) => (x[1] - x[0] > m[1] - m[0] ? x : m), segs[0]);
      const holding = segs.find(([a, z]) => sy0 >= a && sy0 <= z);
      const seg = holding && holding[1] - holding[0] >= Math.min(1.1, widest[1] - widest[0]) ? holding : widest;
      const segMid = (seg[0] + seg[1]) / 2;
      const sy = Math.max(seg[0] + 0.05, Math.min(seg[1] - 0.05, sy0));
      // Stones are specified as a real DIAMETER in mm (1-2.5mm, the range a channel setting in a
      // hard metal actually takes). Before this they were derived from the band width alone and
      // came out around 0.5mm across, which read as dust on the render.
      // FITTING (10 Sep 2026): the bezel is a torus of 1.16r plus a 0.15 tube, so a stone occupies
      // about 1.35r of the face, not r. Sizing against r alone let a row of three hang over both
      // edges. Everything below is measured in that true half-extent, and where a layout runs
      // ACROSS the band the COUNT drops until what is left fits, rather than the stones shrinking
      // to dust.
      const OUT = 1.35;
      const wantR = (parseFloat(c.stoneSize) || 1.5) / 2;
      const segW = Math.max(0.4, seg[1] - seg[0]);
      const halfFace = Math.max(0.2, segW / 2 - 0.06);
      const capR = Math.max(0.18, halfFace / OUT);
      // how many stones of radius r fit across the free run, and the pitch between their centres
      const acrossFit = (r) => {
        const step = 2 * OUT * r + 0.08;
        return { step, n: Math.max(1, Math.floor((segW - 0.12 + 0.08) / step)) };
      };
      // Spacing between stones set along the ring, 0 = shoulder to shoulder, 1 = as far apart as
      // the ring allows, which is four stones around the whole band. The cap is derived per config
      // so the widest setting always means the same thing whatever the stone size.
      const gapT = Math.max(0, Math.min(1, typeof c.stoneGap === 'number' ? c.stoneGap : 0.35));
      // Chord, not arc: on a curve the straight-line gap between two centres is shorter than the
      // angle suggests, so derive the angle from the clearance the bezels actually need.
      const gapAt = (r, y) => {
        const base = 2 * Math.asin(Math.min(0.999, (OUT * r + 0.05) / Math.max(0.001, outerR(y))));
        const cap = Math.max(1, (Math.PI / 2) / base); // four stones around the band
        return base * (1 + gapT * (cap - 1));
      };
      let spots = [];
      if (c.stone === 'Single stone') {
        spots = [{ y: sy, th: camTh, r: Math.min(wantR, capR) }];
      } else if (c.stone === 'Three stones') {
        const sr = Math.min(wantR, capR);
        const dth = gapAt(sr, sy);
        const axis = c.stoneAxis || 'Across the band';
        if (axis === 'Along the ring') {
          spots = [-1, 0, 1].map((k) => ({ y: sy, th: camTh + k * dth, r: sr }));
        } else {
          // Lay the group out about a CENTRE that is itself clamped into the free run, and drop the
          // count until the whole group fits. Clamping each stone separately (the old guard) piled
          // the outer two onto the same edge whenever the run was off-centre, e.g. beside a groove.
          const fit = acrossFit(sr);
          let n = Math.min(3, fit.n);
          const dy = axis === 'Diagonal' ? Math.min(fit.step, Math.max(sr * 2.0, 2 * OUT * sr + 0.08)) : fit.step;
          let half;
          for (;;) {
            half = ((n - 1) / 2) * dy + OUT * sr + 0.04;
            if (n <= 1 || 2 * half <= segW) break;
            n--;
          }
          const cy = Math.max(seg[0] + half, Math.min(seg[1] - half, sy));
          const da = axis === 'Diagonal' ? dth * 0.8 : 0;
          for (let i = 0; i < n; i++) {
            const k = i - (n - 1) / 2;
            spots.push({ y: cy + k * dy, th: camTh + k * da, r: sr });
          }
        }
      } else if (c.stone === 'Row of stones') {
        const span = c.stoneSpan || 'All the way round';
        // A row ACROSS the band is limited by the face, not the circumference: work out how many
        // fit at the chosen size and lay them out along y instead of around th.
        if (span === 'Across the band') {
          const sr = Math.min(wantR, capR);
          const fit = acrossFit(sr);
          const n = Math.min(7, fit.n);
          for (let i = 0; i < n; i++) spots.push({ y: segMid + (i - (n - 1) / 2) * fit.step, th: camTh, r: sr });
        }
        const sr = Math.min(wantR, capR);
        const pitch = gapAt(sr, sy);
        const fixed = spots.length ? null : /^(\d+) stones$/.exec(span);
        if (spots.length) {
          // already laid out across the band
        } else if (fixed) {
          const n = parseInt(fixed[1], 10);
          // A fixed count cannot spread further than the band itself: past 2 pi the last stones
          // wrap round onto the first ones, so cap the pitch at an even share of the ring.
          const p = Math.min(pitch, (Math.PI * 2) / n);
          for (let i = 0; i < n; i++) spots.push({ y: sy, th: camTh + (i - (n - 1) / 2) * p, r: sr });
        } else if (span === 'Half the ring') {

          const n = Math.max(2, Math.round(Math.PI / pitch));
          for (let i = 0; i < n; i++) spots.push({ y: sy, th: camTh + (i - (n - 1) / 2) * (Math.PI / Math.max(1, n - 1)), r: sr });
        } else {
          // All the way round: the count falls out of the pitch, so wider spacing means fewer.
          const n = Math.max(4, Math.round((Math.PI * 2) / pitch));
          for (let i = 0; i < n; i++) spots.push({ y: sy, th: camTh + (i / n) * Math.PI * 2, r: sr });
        }
      }
      // Final safety net only: the layouts above already place whole groups inside the free run,
      // so this may nudge a stone but must never be what separates two of them.
      for (const sp of spots) {
        const lim = OUT * sp.r + 0.04;
        sp.y = Math.max(seg[0] + lim, Math.min(seg[1] - lim, sp.y));
      }
      // A stone that lands on a groove must still sit on the ring's SURFACE: outerR dips by the
      // groove depth, which buried the middle stone of a three-across set (10 Sep 2026). Add the
      // dip back so the setting bridges the groove rather than sinking into it.
      const stoneR = (y) => {
        let r = outerR(y);
        for (const gr of grooves) { const d = Math.abs(y - gr.y); if (d < gr.half) r += 0.25 * Math.cos((d / gr.half) * Math.PI / 2); }
        return r;
      };
      // Thickness is how far light travels inside the stone, so it has to track the stone's size.
      if (sMat.transmission) sMat.thickness = Math.max(0.15, (spots[0] ? spots[0].r : 0.5) * 1.9);
      for (const sp of spots) {
        const dir = new THREE.Vector3(Math.cos(sp.th), 0, Math.sin(sp.th));
        // the stone sinks slightly below the surface; the bezel sits just proud of it
        // THE TABLE MUST CLEAR THE FACE STRIP. A textured finish lays a strip at outerR + 0.02 and
        // the bezel sits at + 0.03, so a stone centred at -0.3r puts its table exactly level with
        // the bare band and BURIED under both: the row rendered as empty bezel circles with the
        // metal showing through (21 Sep 2026). The old cone only escaped this by accident, its flat
        // base standing 0.55r proud. Offsetting by 0.045 - 0.3r lands the table 0.045 above the
        // surface whatever the stone's size, which is what a flush setting actually looks like.
        // A STONE SET IN A METAL LINE (22 Sep 2026, a customer's design): the line sits at +0.052,
        // above both the table (+0.045) and the bezel (+0.03), so it painted straight over them and
        // left empty rims with a sliver of crown poking through. Where the stone overlaps any drawn
        // line span, the whole setting is lifted to clear the line by the same margins it keeps
        // over the bare band. Stones off the line are untouched.
        let onLine = false;
        for (const [sa, sb] of pinSpans) if (sp.y + sp.r > sa && sp.y - sp.r < sb) { onLine = true; break; }
        // SEAT THE CROWN AT THE TOP OF WHATEVER COVERS THE BAND, so the whole crown is visible and
        // the rim closes on it. The old seating put the TABLE just above the cover, which left only
        // the table showing and most of the crown under the face strip or line, inside a rim
        // nearly twice its size. The crown ring sits 0.13r above the girdle, hence the offset.
        const cover = (onLine ? 0.052 : 0.027) + 0.01;
        for (const [geo2, mat, ro] of [[cone, sMat, cover - sp.r * 0.13], [bezG, bezMat, cover]]) {
          const rr = stoneR(sp.y) + ro;
          const pos = new THREE.Vector3(dir.x * rr, sp.y, dir.z * rr);
          const m = new THREE.Mesh(geo2, mat);
          m.scale.setScalar(sp.r); m.position.copy(pos); m.lookAt(pos.clone().sub(dir));
          g.add(m);
        }
      }
    }
    // sleeve
    if (c.sleeve && SLEEVES[c.sleeve]) {
      const sp = boreLathe(-0.03, -hw + 0.08, hw - 0.08);
      g.add(new THREE.Mesh(new THREE.LatheGeometry(sp, 160), this.mat(SLEEVES[c.sleeve])));
    } else if (mdef.organic) {
      // organic bore: same material, no laser engraving
      const op = boreLathe(-0.015, -hw + 0.06, hw - 0.06);
      const om = this.mat({ tex: mdef.tex, color: 0xffffff, rough: mdef.rough, side: THREE.DoubleSide });
      const omesh = new THREE.Mesh(new THREE.LatheGeometry(op, 160), this.lift(om, 1));
      omesh.renderOrder = 1; g.add(omesh);
    } else {
      // metal bore: FOUNDORIA laser engraving, sized in mm so narrow bands never squash it, etch tone picked for contrast
      const boreCol = c.sleeveHex ? new THREE.Color(c.sleeveHex).getHex() : mdef.color;
      const colHexStr = '#' + new THREE.Color(boreCol).getHexString();
      const lum = (parseInt(colHexStr.slice(1, 3), 16) * 0.299 + parseInt(colHexStr.slice(3, 5), 16) * 0.587 + parseInt(colHexStr.slice(5, 7), 16) * 0.114);
      const eKey = colHexStr + '|' + w + '|' + R.toFixed(2);
      if (!this._engraveKey || this._engraveKey !== eKey) {
        const cv = document.createElement('canvas'); cv.width = 2048; cv.height = 256;
        const t = new THREE.CanvasTexture(cv);
        t.wrapS = t.wrapT = THREE.RepeatWrapping; t.colorSpace = THREE.SRGBColorSpace;
        // This is the HARSHEST minification in the scene: 2048x256 wrapped round the full
        // circumference and squeezed onto a strip a few screen pixels tall, so it aliased worse
        // than the relief maps sharpen() was written for and the mark read differently frame to
        // frame. It is built inline rather than through tex(), so sharpen() has to be called here
        // by hand. Safe with the needsUpdate guard: the canvas has a width immediately, and the
        // wordmark's onload below flags the upload once the image actually arrives.
        this.sharpen(t);
        const wm = new Image();
        wm.onload = () => {
          const cx = cv.getContext('2d');
          cx.fillStyle = colHexStr; cx.fillRect(0, 0, cv.width, cv.height);
          // glyph fixed at 1.5mm tall; aspect preserved in mm space (v = w mm / 256px, u = 2πR mm / 2048px)
          const lh = cv.height * (1.5 / w), lw = lh * (wm.width / wm.height) * ((w / cv.height) / ((2 * Math.PI * R) / cv.width));
          cx.save();
          if (lum > 90) { cx.filter = 'invert(1)'; cx.globalAlpha = 0.55; } // dark etch on light metal
          else { cx.globalAlpha = 0.7; }                                    // keep white etch on dark metal
          cx.translate(cv.width / 2, 0); cx.scale(-1, 1); cx.translate(-cv.width / 2, 0); // mirror so it reads correctly on the bore
          cx.drawImage(wm, (cv.width - lw) / 2, (cv.height - lh) / 2, lw, lh);
          cx.restore();
          t.needsUpdate = true;
        };
        wm.crossOrigin = 'anonymous'; wm.src = A('assets/foundoria-wordmark.png');
        if (this._engraveTex) this._engraveTex.dispose();
        this._engraveTex = t; this._engraveKey = eKey;
      }
      const ep = boreLathe(-0.015, -hw + 0.06, hw - 0.06);
      const em = new THREE.MeshPhysicalMaterial({ map: this._engraveTex, color: 0xffffff, metalness: 0.75, roughness: c.sleeveHex ? 0.12 : 0.35, envMapIntensity: c.sleeveHex ? 1.6 : 1.0, side: THREE.DoubleSide });
      // The bore strip sits only 0.015 inside the band's inner wall, so it is a depth-fight risk in
      // its own right: the engraved mark broke up and crawled at anything but close zoom. Lifted
      // like the face overlays.
      const emesh = new THREE.Mesh(new THREE.LatheGeometry(ep, 160), this.lift(em, 1));
      emesh.renderOrder = 1; g.add(emesh);
    }
    // A PLAIN BEVEL IS POLISHED (merchant, 23 Sep 2026: the default, and what the specs say). The
    // bevel is part of the band lathe, so it was taking the FACE's roughness and read matte on every
    // worked finish (faceted adds +0.12). Lay a polished strip over the bevel span only, following
    // its cut. Skipped where a contrast edge or bevel colour already draws its own strip above.
    if (!mdef.organic && bevel && !(c.edge === 'Polished edge contrast' || c.zircEdges || c.bevelHex)) {
      // c.bevelFinish 'Brushed' (23 Sep 2026) takes the same fine-brush treatment as a brushed zone.
      const brushedBevel = c.bevelFinish === 'Brushed';
      const pbMat = this.mat({ ...mdef, rough: brushedBevel ? 0.42 : 0.08 });
      if (brushedBevel) { const bt = this.tex('brushfine'); pbMat.bumpMap = bt; pbMat.bumpScale = 0.008; pbMat.roughnessMap = bt; pbMat.roughness = 0.72; }
      pbMat.side = THREE.DoubleSide;
      // Split on the band's CENTRE, not on faceLo: the lower strip's last point sits exactly ON
      // faceLo, and a `y < faceLo` test sent it to the upper formula, which extrapolates across the
      // whole face and threw that one ring of vertices out by ~0.55 x face width - a flat brim.
      const bR = (y) => y < 0 ? outerR(faceLo) - bevel * 0.55 * ((faceLo - y) / bevel)
        : outerR(faceHi) - bevel * 0.55 * ((y - faceHi) / bevel);
      for (const [a, b] of [[-hw, faceLo], [faceHi, hw]]) {
        const ep = []; const M = 8;
        for (let i = 0; i <= M; i++) { const y = a + (i / M) * (b - a); ep.push(new THREE.Vector2(bR(y) + 0.02, y)); }
        const pb = new THREE.Mesh(new THREE.LatheGeometry(ep, 160), this.lift(pbMat, 2));
        pb.renderOrder = 2; g.add(pb);
      }
    }
    // polished edge contrast or two-tone raw zirconium: bright strips at the edges
    if (!mdef.organic && (c.edge === 'Polished edge contrast' || c.zircEdges || c.bevelHex)) {
      const edgeMat = c.bevelHex ? this.mat({ color: new THREE.Color(c.bevelHex).getHex(), rough: 0.08 }) : c.zircEdges ? this.mat({ color: RAWZ, rough: 0.3 }) : this.mat({ ...mdef, rough: 0.06 });
      // A coloured bevel can be brushed matte too (31 Oct 2026): same fine-brush treatment as the plain bevel.
      if (c.bevelHex && c.bevelFinish === 'Brushed') { const bt = this.tex('brushfine'); edgeMat.bumpMap = bt; edgeMat.bumpScale = 0.008; edgeMat.roughnessMap = bt; edgeMat.roughness = 0.72; }
      edgeMat.side = THREE.DoubleSide;
      // Strip width is the customer's choice (edgeW, default 0.9mm); still floored against a bevel or
      // step so the cut edge always keeps a visible band.
      // A bevel COLOUR (20 Oct 2026) covers the bevel and nothing else; the 0.9 default spilled onto the face.
      const bw = c.bevelHex && bevel ? bevel : Math.max(c.edgeW || 0.9, Math.max(bevel, step) + 0.01);
      // follow the real edge profile so a bevel/step keeps its cut
      const edgeR = (y) => {
        if (bevel) {
          if (y < faceLo) return outerR(faceLo) - bevel * 0.55 * ((faceLo - y) / bevel);
          if (y > faceHi) return outerR(faceHi) - bevel * 0.55 * ((y - faceHi) / bevel);
        } else if (step) {
          if (y < faceLo || y > faceHi) return outerR(y < faceLo ? faceLo : faceHi) - 0.35;
        }
        return outerR(y);
      };
      for (const [a, b] of [[-hw, -hw + bw], [hw - bw, hw]]) {
        const ep = []; const M = 10;
        for (let i = 0; i <= M; i++) { const y = a + (i / M) * (b - a); ep.push(new THREE.Vector2(edgeR(y) + 0.03, y)); }
        const e2 = new THREE.Mesh(new THREE.LatheGeometry(ep, 160), this.lift(edgeMat, 2));
        e2.renderOrder = 2; g.add(e2);
      }
      // side walls (the flat top/bottom faces) take the same colour
      if (c.bevelHex || c.zircEdges) {
        for (const yy of [-hw, hw]) {
          const off = yy < 0 ? -0.015 : 0.015;
          const sp = [new THREE.Vector2(innerR(yy) + 0.02, yy + off), new THREE.Vector2(edgeR(yy) + 0.02, yy + off)];
          const emesh = new THREE.Mesh(new THREE.LatheGeometry(sp, 160), this.lift(edgeMat, 2));
          emesh.renderOrder = 2; g.add(emesh);
        }
      }
    }
    // KEEP A HAMMER MARK THE SAME SIZE IN MILLIMETRES. Every finish photo is tiled a fixed number of
    // times AROUND the band, which was tuned on the old 11.25 outer radius, so on a bigger ring the
    // pattern would stretch and on a smaller one it would crowd. Scale the around-the-band repeat by
    // circumference. _rx0 remembers each texture's own tuned figure, so rebuilding at a new size
    // scales from that rather than compounding.
    const kC = (R + T) / 11.25;
    for (const key in this.textures) {
      const t = this.textures[key];
      if (!t || !t.isTexture) continue;
      if (t._rx0 == null) t._rx0 = t.repeat.x;
      const want = t._rx0 * kC;
      if (Math.abs(t.repeat.x - want) > 1e-6) t.repeat.x = want;
    }
  }
}
customElements.define('ring-viewer', RingViewer);
